var _defs, _style, _g, _path, _g2, _path2, _g3, _path3, _path4, _g4, _path5, _path6, _g5, _g6, _g7, _g8, _path7, _path8, _path9, _path10, _path11, _path12, _g9, _path13, _g10, _path14, _path15, _g11, _path16, _path17, _g12, _path18, _g13, _path19, _g14, _path20, _path21, _g15, _g16, _g17, _g18, _path22, _g19, _path23, _path24, _path25, _path26, _path27, _g20, _path28, _path29, _path30, _path31, _g21, _path32, _path33, _path34, _g22, _g23, _g24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiplomatechIllustration1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1026-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m703.8 698.42c0 20.93-14.69 29.41-32.82 18.95c-18.13-10.46-32.82-35.91-32.82-56.84c0-20.93 14.69-29.41 32.82-18.95c18.13 10.46 32.82 35.91 32.82 56.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grd1",
    gradientUnits: "userSpaceOnUse",
    x1: 1024.6,
    y1: 543.9,
    x2: 1136.4,
    y2: 543.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17e8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e24098"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #173d7a } \n\t\t.s2 { fill: #117aca } \n\t\t.s3 { fill: #5793ce } \n\t\t.s4 { fill: #396caa } \n\t\t.s5 { fill: #ff2c9c } \n\t\t.s6 { fill: #274f89 } \n\t\t.s7 { fill: #d4ecff } \n\t\t.s8 { fill: #fafdff } \n\t\t.s9 { opacity: .4;fill: #d4ecff } \n\t\t.s10 { fill: #b3e0ff } \n\t\t.s11 { opacity: .2;fill: #a49fff } \n\t\t.s12 { fill: #092e63 } \n\t\t.s13 { fill: #2c2660 } \n\t\t.s14 { fill: url(#grd1) } \n\t\t.s15 { fill: #17e8f7 } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "\\\\\\\\321\\\\\\\\353\\\\\\\\356\\\\\\\\351 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6,
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m1045.48 294.28l-46.61-26.91l46.6-26.91l46.61 26.91l-46.6 26.91zm-42.55-26.91l42.55 24.57l42.55-24.57l-42.55-24.57l-42.55 24.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1076.14 258.52l-30.66 17.7v-35.4l30.66-17.7v35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1045.48 240.82l-30.66-17.7l30.66-17.7l30.66 17.7l-30.66 17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1045.48 276.23l-30.66-17.7v-35.4l30.66 17.7v35.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1034.44 257.1l-8.58-4.95v-9.9l8.58 4.95v9.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m93.28 548.01l-46.61-26.91l46.6-26.91l46.61 26.91l-46.6 26.91zm-42.55-26.91l42.55 24.57l42.55-24.57l-42.55-24.57l-42.55 24.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m123.94 512.25l-30.66 17.7v-35.4l30.66-17.7v35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m93.28 494.55l-30.66-17.7l30.66-17.7l30.66 17.7l-30.66 17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m93.28 529.95l-30.66-17.7v-35.4l30.66 17.7v35.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m82.24 510.83l-8.58-4.95v-9.9l8.58 4.95v9.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m640.84 196.49l-106.88-61.92l119.76-68.95l106.88 61.92l-119.76 68.95zm-102.83-61.92l102.83 59.58l115.7-66.61l-102.83-59.58l-115.7 66.61z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m710.88 126.15l-10.39-6l38.3-22.11c1.81-1.04 1.81-2.74 0-3.79l-39.12-22.59c-1.81-1.04-4.75-1.04-6.56 0l-38.3 22.11l-10.39-6l38.3-22.11c7.54-4.35 19.8-4.35 27.33 0l39.12 22.59c7.54 4.35 7.54 11.43 0 15.78l-38.3 22.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m725.44 134.62l0 0l0 0c-0.23 0.17-0.47 0.3-0.72 0.42l-81.62 47.37l-80.12-60.37l82.85-48.14l0 0c1.32-0.74 3.02-0.66 4.89 0.42l69.39 40.06c4.16 2.4 7.54 8.86 7.54 14.41c0 2.77-0.84 4.8-2.21 5.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m632.57 174.48l93.04-53.72c1.26 2.52 2.03 5.37 2.03 8.02c0 2.77-0.84 4.8-2.21 5.83l0 0l0 0c-0.23 0.17-0.47 0.3-0.72 0.42l-81.62 47.37l-10.53-7.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m637.88 182.2l-69.39-40.06c-4.16-2.4-7.54-8.86-7.54-14.41c0-5.55 3.38-8.11 7.54-5.7l69.39 40.06c4.16 2.4 7.54 8.86 7.54 14.41c0 5.55-3.38 8.11-7.54 5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m646.25 176.12v0c0 3.51-1.35 5.81-3.39 6.43c1.56-0.94 2.55-3.05 2.55-6.05v0c0-5.55-3.38-12-7.54-14.41l-69.39-40.06c-1.54-0.89-2.96-1.09-4.15-0.73c1.33-0.8 3.07-0.75 4.99 0.35l69.39 40.06c4.16 2.4 7.54 8.86 7.54 14.41z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m627.48 168.69l-8.34-4.81c-0.83-0.48-1.5-1.76-1.5-2.87c0-1.11 0.67-1.62 1.5-1.14l8.34 4.81c0.83 0.48 1.5 1.77 1.5 2.87c0 1.11-0.67 1.62-1.5 1.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m630.2 112.52c-2.21-1.24-2.23-3.3-0.05-4.59c2.18-1.29 5.74-1.33 7.94-0.08c2.21 1.24 2.23 3.3 0.05 4.59c-2.18 1.29-5.74 1.33-7.94 0.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m642.31 119.34c-2.21-1.24-2.23-3.3-0.05-4.59c2.18-1.29 5.74-1.33 7.94-0.08c2.21 1.24 2.23 3.3 0.05 4.59c-2.18 1.29-5.74 1.33-7.94 0.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m654.41 126.16c-2.21-1.24-2.23-3.3-0.05-4.59c2.18-1.29 5.74-1.33 7.94-0.08c2.21 1.24 2.23 3.3 0.05 4.59c-2.18 1.29-5.74 1.33-7.94 0.08z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m401.86 315.48l-171.95-99.56l131.87-75.98l171.95 99.56l-131.87 75.98zm-167.9-99.56l167.9 97.22l127.82-73.64l-167.9-97.22l-127.82 73.64z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m1034.67 480.26l-0.51-0.29l-228.58-132.19l131.87-75.98l0.51 0.29l228.58 132.19l-131.87 75.98zm-225.04-132.48l225.04 130.14l127.82-73.64l-225.04-130.14l-127.82 73.64z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m526.35 123.72l-21.28 96.75c-0.53 2.41-1.81 4.1-3.41 4.84l-4.76 1.84l0.42-4.98l-117.51-67.85c-3.41-1.97-5.37-7.18-4.39-11.65l21.27-96.75c0.02-0.07 0.04-0.14 0.06-0.21l-3.91-1.91l4.35-1.66c0.02-0.01 0.04-0.01 0.05-0.02l0.22-0.08l-0.01 0.01c1.26-0.43 2.68-0.31 4.08 0.5l120.41 69.52c3.41 1.97 5.37 7.18 4.39 11.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m525.76 116.87l-84.73 41.28l-58.91-45.9l14.59-66.32c0.02-0.07 0.04-0.14 0.06-0.21l-3.91-1.91l4.35-1.66c0.02-0.01 0.04-0.01 0.05-0.02l0.22-0.08l-0.01 0.01c1.26-0.43 2.68-0.31 4.08 0.5l120.41 69.52c1.68 0.97 3 2.73 3.8 4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m508.36 118.82l14.51-6.1c2.41 1.96 3.88 5.63 3.71 9.18l-9.17 3.9l-9.06-6.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m492.73 226.69l-120.41-69.52c-3.41-1.97-5.37-7.18-4.39-11.65l21.28-96.75c0.98-4.47 4.54-6.5 7.94-4.53l120.41 69.52c3.41 1.97 5.37 7.18 4.39 11.65l-21.28 96.75c-0.98 4.47-4.54 6.5-7.94 4.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m523.1 124.99l-21.28 96.75c-0.63 2.87-2.33 4.71-4.36 5.16c1.5-0.79 2.7-2.43 3.2-4.73l21.28-96.75c0.98-4.47-0.98-9.68-4.39-11.65l-120.41-69.52c-1.22-0.7-2.45-0.88-3.58-0.63c1.41-0.75 3.09-0.75 4.74 0.21l120.41 69.52c3.41 1.97 5.37 7.18 4.39 11.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m490.12 220.05l-113.24-65.35c-3.12-1.8-4.92-6.57-4.02-10.66l19.61-89.17c0.9-4.09 4.15-5.94 7.27-4.14l113.24 65.35c3.12 1.8 4.92 6.57 4.02 10.66l-19.61 89.17c-0.9 4.09-4.15 5.94-7.27 4.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m490.12 220.05l-113.24-65.35c-3.12-1.8-4.92-6.57-4.02-10.66l19.61-89.17c0.9-4.09 4.15-5.94 7.27-4.14l113.24 65.35c3.12 1.8 4.92 6.57 4.02 10.66l-19.61 89.17c-0.9 4.09-4.15 5.94-7.27 4.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m494.53 220.21c-1.31 0.72-2.88 0.73-4.42-0.16l-113.24-65.35c-3.12-1.8-4.92-6.57-4.02-10.66l19.61-89.17c0.56-2.56 2.05-4.24 3.84-4.7c-1.34 0.74-2.4 2.23-2.85 4.3l-19.61 89.17c-0.9 4.09 0.9 8.86 4.02 10.66l113.24 65.35c1.17 0.67 2.35 0.84 3.43 0.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m494.39 235.2c0.06 1.55-1.04 3.19-3.25 4.47l-81.99 47.32c-3.93 2.27-9.88 2.52-13.29 0.55l-120.41-69.52c-1.61-0.93-2.35-2.18-2.29-3.49l-0.01 0v-5.65l9.95 1.31l75.28-43.45c3.93-2.27 9.88-2.52 13.29-0.55l106.25 61.34l16.46 2.17v5.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m402.72 288.83c-2.55 0.17-5.06-0.25-6.86-1.29l-120.41-69.52c-1.61-0.93-2.35-2.18-2.29-3.49l-0.01 0v-5.65l9.95 1.31l40.91-23.6h82.99l7.55 4.36l-11.84 97.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m277.58 219.25l-2.12-1.23c-1.61-0.93-2.35-2.18-2.29-3.49l-0.01 0v-5.65l4.42 0.58v9.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m397.08 274.81h11.29v12.6c-3.45 1.66-8.06 1.93-11.29 0.7v-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m395.86 281.9l-120.41-69.52c-3.41-1.97-2.98-5.4 0.95-7.67l81.99-47.32c3.93-2.27 9.88-2.52 13.29-0.55l120.41 69.52c3.41 1.97 2.98 5.4-0.95 7.67l-81.99 47.32c-3.93 2.27-9.88 2.52-13.29 0.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m494.21 228.68c0.62 1.78-0.43 3.83-3.07 5.36l-81.99 47.32c-3.93 2.27-9.88 2.52-13.29 0.55l-120.41-69.52c-1.97-1.14-2.65-2.77-2.12-4.38c0.3 0.87 1 1.67 2.12 2.32l120.41 69.52c3.41 1.97 9.36 1.72 13.29-0.55l81.99-47.32c1.66-0.96 2.68-2.12 3.07-3.29z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m326.67 189.37l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l6.43-3.71c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-6.43 3.71c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m335.08 194.23l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l6.43-3.71c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-6.43 3.71c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m343.49 199.09l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l6.43-3.71c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-6.43 3.71c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m355.13 195.08l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m363.54 199.93l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.5-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m371.96 204.79l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m380.37 209.65l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m388.78 214.51l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m397.2 219.36l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m405.61 224.22l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.5-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m414.02 229.08l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m422.44 233.94l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m430.85 238.79l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.5-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m367.53 192.78l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m358.99 187.85l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m350.43 182.91l-11.73-6.77c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.5-0.29 1.27-0.32 1.71-0.07l11.73 6.77c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m356.41 176.9l-9.52-5.5c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l9.52 5.5c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m375.94 197.63l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m384.35 202.49l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m392.77 207.35l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.5-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m401.18 212.21l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m409.59 217.06l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m418 221.92l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m426.42 226.78l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m434.83 231.64l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m443.24 236.49l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m458.2 245.13l-11.89-6.86c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l11.89 6.86c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m474.58 235.67l-10.03-5.79c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l10.03 5.79c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m390.67 196.68l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m382.05 191.71l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.5-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m373.43 186.73l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m364.8 181.75l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m399.09 201.54l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m407.5 206.4l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m415.91 211.26l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.5-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m424.33 216.11l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m432.74 220.97l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m441.15 225.83l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.5-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m449.57 230.69l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m457.98 235.54l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m466.39 240.4l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m386.24 184.67l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m377.87 179.84l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m369.5 175l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m361.13 170.17l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m369.74 165.2l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l1.78-1.03c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-1.78 1.03c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m380.66 171.51l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l1.78-1.03c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-1.78 1.03c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m389 176.32l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l1.78-1.03c0.5-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-1.78 1.03c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m397.33 181.13l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l1.78-1.03c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-1.78 1.03c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m405.67 185.95l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l1.78-1.03c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-1.78 1.03c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m452.21 212.82l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l1.78-1.03c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-1.78 1.03c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m460.55 217.63l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l1.78-1.03c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-1.78 1.03c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m468.88 222.44l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l1.78-1.03c0.5-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-1.78 1.03c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m477.22 227.26l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l1.78-1.03c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-1.78 1.03c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m394.66 189.53l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m403.07 194.38l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.5-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m411.48 199.24l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.5-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m419.89 204.1l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m428.31 208.96l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m436.72 213.81l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m445.13 218.67l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m453.55 223.53l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m461.96 228.39l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m346.56 190.13l-16.04-9.26c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l16.04 9.26c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m449.91 249.8l-16.04-9.26c-0.44-0.25-0.38-0.69 0.12-0.99l5.4-3.12c0.51-0.29 1.27-0.32 1.71-0.07l16.04 9.26c0.44 0.25 0.38 0.69-0.12 0.99l-5.4 3.12c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m416.27 241.1l-5.45-3.15c-0.44-0.25-0.38-0.69 0.12-0.99l6.43-3.71c0.51-0.29 1.27-0.32 1.71-0.07l5.45 3.15c0.44 0.25 0.38 0.69-0.12 0.99l-6.43 3.71c-0.5 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m355.17 205.83l-8.71-5.03c-0.44-0.25-0.38-0.69 0.12-0.99l6.43-3.71c0.51-0.29 1.27-0.32 1.71-0.07l8.71 5.03c0.44 0.25 0.38 0.69-0.12 0.99l-6.43 3.71c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m408.16 236.42l-8.71-5.03c-0.44-0.25-0.38-0.69 0.12-0.99l6.43-3.71c0.51-0.29 1.27-0.32 1.71-0.07l8.71 5.03c0.44 0.25 0.38 0.69-0.12 0.99l-6.43 3.71c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m367.31 212.84l-8.71-5.03c-0.44-0.25-0.38-0.69 0.12-0.99l6.43-3.71c0.51-0.29 1.27-0.32 1.71-0.07l8.71 5.03c0.44 0.25 0.38 0.69-0.12 0.99l-6.43 3.71c-0.51 0.29-1.27 0.32-1.71 0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m366.92 203.07l37.88 21.87c0.47 0.27 0.47 0.71 0 0.98l-6.56 3.79c-0.47 0.27-1.23 0.27-1.7 0l-37.88-21.87l8.26-4.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m439.78 249.91l6.07 3.5c0.36 0.21 0.31 0.57-0.1 0.81l-2.63 1.52c-0.41 0.24-1.04 0.26-1.4 0.06l-6.07-3.5c-0.36-0.21-0.31-0.57 0.1-0.81l2.63-1.52c0.41-0.24 1.04-0.26 1.4-0.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m431.3 245.01l6.07 3.5c0.36 0.21 0.31 0.57-0.1 0.81l-2.63 1.52c-0.41 0.24-1.04 0.27-1.4 0.06l-6.07-3.5c-0.36-0.21-0.31-0.57 0.1-0.81l2.63-1.52c0.41-0.24 1.04-0.26 1.4-0.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m422.89 240.16l6.07 3.5c0.36 0.21 0.31 0.57-0.1 0.81l-2.63 1.52c-0.41 0.24-1.04 0.26-1.4 0.06l-6.07-3.5c-0.36-0.21-0.31-0.57 0.1-0.81l2.63-1.52c0.41-0.24 1.04-0.26 1.4-0.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m435.95 242.33l6.07 3.5c0.36 0.21 0.31 0.57-0.1 0.81l-2.63 1.52c-0.41 0.24-1.04 0.27-1.4 0.06l-6.07-3.5c-0.36-0.21-0.31-0.57 0.1-0.81l2.63-1.52c0.41-0.24 1.04-0.27 1.4-0.06z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m419.03 95.68l-13.68-7.9l0.58-2.95l13.68 7.9l-0.58 2.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m417.55 102.53l-13.68-7.9l0.58-2.95l13.68 7.9l-0.58 2.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m484.71 197.5l-13.68-7.9l0.58-2.95l13.68 7.9l-0.58 2.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m414.58 116.22l-13.68-7.9l0.58-2.95l13.68 7.9l-0.58 2.95z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m587.73 645.31l-0.51-0.29l-242.9-139.95l1.52-0.88l297.07-171.51l0.51 0.29l242.9 139.95l-1.52 0.88l-297.07 171.51zm-239.36-140.24l239.36 137.91l294.53-170.05l-239.36-137.91l-294.53 170.05z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m634.51 344.46l-1.01-1.75l209.07-120.7l1.01 1.75l-209.07 120.7z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m554.35 431.26v-175.94l69.95-18.31l12.88-7.44c2.96-1.71 8.12-1.49 11.54 0.48l12.02 6.94l37.31-0.02l-11.05 169.85c0.08 1.16-0.56 2.27-1.98 3.09l-69.8 52.67c-2.96 1.71-8.12 1.49-11.54-0.48l-46.52-26.86c-1.97-1.14-2.92-2.61-2.81-3.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m642.54 228.42c2.16 0.05 4.41 0.6 6.18 1.62l12.02 6.94l37.31-0.02v176.42c0.08 1.16-0.56 2.27-1.98 3.09l-80.85 46.1c-1.42 0.82-3.35 1.19-5.35 1.14l-0.83-177.52l33.51-57.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m614.47 462.94c-2.55 1.09-6.24 1.03-9.22-0.11v-178.73h9.22v178.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m603.68 285.74l-46.52-26.86c-3.41-1.97-3.79-4.95-0.83-6.66l80.85-46.1c2.96-1.71 8.12-1.49 11.54 0.48l46.52 26.86c3.41 1.97 3.79 4.95 0.83 6.66l-80.85 46.1c-2.96 1.71-8.12 1.49-11.54-0.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m557.16 255.61l46.52 26.86c3.41 1.97 8.58 2.19 11.54 0.48l80.85-46.1c0.66-0.38 1.14-0.83 1.48-1.31c1.02 1.63 0.56 3.41-1.48 4.58l-80.85 46.1c-2.96 1.71-8.12 1.49-11.54-0.48l-46.52-26.86c-2.65-1.53-3.46-3.67-2.3-5.35c0.46 0.75 1.23 1.46 2.3 2.08z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m607.53 267.31l-21.77-12.57c-1.6-0.92-1.77-2.32-0.39-3.12l53.83-31.2c1.38-0.8 3.8-0.7 5.4 0.22l21.77 12.57c1.6 0.92 1.77 2.32 0.39 3.12l-53.83 31.2c-1.38 0.8-3.8 0.7-5.4-0.22z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m641.24 237.7l-3.01-1.74c-0.22-0.13-0.24-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m630.82 243.69l-3.01-1.74c-0.22-0.13-0.25-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m620.4 249.69l-3.01-1.74c-0.22-0.13-0.25-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m609.98 255.68l-3.01-1.74c-0.22-0.13-0.24-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m666.76 236.33l-0.06 0.04c-0.11-0.08-0.2-0.15-0.32-0.22l-21.77-12.57c-1.6-0.92-4.01-1.02-5.4-0.22l-53.76 31.16c-1.28-0.91-1.34-2.16-0.06-2.89l53.83-31.2c1.38-0.8 3.8-0.7 5.4 0.22l21.77 12.57c1.6 0.92 1.77 2.32 0.39 3.12z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m594.6 321.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m562.48 283.96c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m585.39 309.19l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m576.01 303.77l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m594.6 400.16l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m562.48 363.05c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m585.39 388.27l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m576.01 382.85l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m594.6 439.71l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m562.48 402.59c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m585.39 427.82l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m576.01 422.4l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m594.6 360.62l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m562.48 323.51c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m585.39 348.73l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m576.01 343.31l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m618.24 307.71v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m621.68 304.05v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m674.41 268.55c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m668.98 269.81c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m663.24 273.12c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m657.49 276.44c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m651.75 279.75c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m625.03 298.83v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.4 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m618.24 331.45v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.77c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m621.68 327.8v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m674.41 292.29c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m668.98 293.55c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m663.24 296.86c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m657.49 300.18c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m651.75 303.49c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m625.03 322.57v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.4 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m618.24 355.19v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m621.68 351.54v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m674.41 316.04c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m668.98 317.29c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m663.24 320.6c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m657.49 323.92c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m651.75 327.24c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m625.03 346.32v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.4 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m618.24 378.93v-13.46c0-2.11 1.28-4.55 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m621.68 375.28v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m674.41 339.78c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m668.98 341.03c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m663.24 344.35c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m657.49 347.66c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m651.75 350.98c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m625.03 370.06v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.4 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m618.24 402.68v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.77c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m621.68 399.02v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m674.41 363.52c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m668.98 364.77c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m663.24 368.09c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m657.49 371.4c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m651.75 374.72c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m625.03 393.8v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.4 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m618.24 426.42v-13.46c0-2.11 1.28-4.55 2.86-5.47l70.61-40.77c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m621.68 422.76v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m674.41 387.26c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m668.98 388.51c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m663.24 391.83c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m657.49 395.15c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m651.75 398.46c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m625.03 417.54v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.4 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m618.24 450.16v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.77c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m621.68 446.5v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m674.41 411c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m668.61 411.03c1.7-0.98 3.07-0.19 3.07 1.78c0 1.96-1.38 4.35-3.07 5.33c-1.7 0.98-3.07 0.19-3.07-1.78c0-1.96 1.38-4.35 3.07-5.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m655.27 420.5c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m649.53 423.82c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m643.78 427.13c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m625.03 441.28v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.4 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m424.6 505.95v-175.94l69.95-18.31l12.88-7.44c2.96-1.71 8.12-1.49 11.54 0.48l12.02 6.94l37.31-0.02l-11.05 169.85c0.08 1.16-0.56 2.27-1.98 3.09l-69.8 52.67c-2.96 1.71-8.12 1.49-11.54-0.48l-46.52-26.86c-1.97-1.14-2.92-2.61-2.81-3.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m512.78 303.12c2.16 0.05 4.41 0.6 6.18 1.62l12.02 6.94l37.31-0.02v176.42c0.08 1.16-0.56 2.27-1.98 3.09l-80.85 46.1c-1.42 0.82-3.35 1.19-5.35 1.14l-0.83-177.52l33.51-57.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m484.72 537.63c-2.55 1.09-6.24 1.03-9.22-0.11v-178.73h9.22v178.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m473.93 359.44l-46.52-26.86c-3.41-1.97-3.79-4.95-0.83-6.66l80.85-46.1c2.96-1.71 8.12-1.49 11.54 0.48l46.52 26.86c3.41 1.97 3.79 4.95 0.83 6.66l-80.85 46.1c-2.96 1.71-8.12 1.49-11.54-0.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m427.41 330.31l46.52 26.86c3.41 1.97 8.58 2.19 11.54 0.48l80.85-46.1c0.66-0.38 1.14-0.83 1.48-1.31c1.02 1.63 0.56 3.41-1.48 4.58l-80.85 46.1c-2.96 1.71-8.12 1.49-11.54-0.48l-46.52-26.86c-2.65-1.53-3.46-3.67-2.3-5.35c0.46 0.75 1.23 1.46 2.3 2.08z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m477.78 342.01l-21.77-12.57c-1.6-0.92-1.77-2.32-0.39-3.12l53.83-31.2c1.38-0.8 3.8-0.7 5.4 0.22l21.77 12.57c1.6 0.92 1.77 2.32 0.39 3.12l-53.83 31.2c-1.38 0.8-3.8 0.7-5.4-0.22z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m511.49 312.4l-3.01-1.74c-0.22-0.13-0.24-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m501.07 318.39l-3.01-1.74c-0.22-0.13-0.24-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m490.65 324.38l-3.01-1.74c-0.22-0.13-0.25-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m480.23 330.37l-3.01-1.74c-0.22-0.13-0.24-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m537 311.03l-0.06 0.04c-0.11-0.08-0.2-0.15-0.32-0.22l-21.77-12.57c-1.6-0.92-4.01-1.02-5.4-0.22l-53.76 31.16c-1.28-0.91-1.34-2.16-0.06-2.89l53.83-31.2c1.38-0.8 3.8-0.7 5.4 0.22l21.77 12.57c1.6 0.92 1.77 2.32 0.39 3.12z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m464.84 395.77l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m432.73 358.66c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m455.64 383.88l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m446.25 378.46l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m464.84 474.86l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m432.73 437.75c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m455.64 462.97l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m446.25 457.55l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m464.84 514.4l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m432.73 477.29c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m455.64 502.51l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m446.25 497.09l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m464.84 435.32l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m432.73 398.2c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m455.64 423.43l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m446.25 418.01l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m488.49 382.41v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.55-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m491.93 378.75v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m544.65 343.25c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m539.23 344.5c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m533.48 347.82c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m527.74 351.13c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m522 354.45c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m495.27 373.53v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m488.49 406.15v-13.46c0-2.11 1.28-4.55 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.77c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m491.93 402.49v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m544.65 366.99c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m539.23 368.24c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m533.48 371.56c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m527.74 374.88c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m522 378.19c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m495.27 397.27v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m488.49 429.89v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.55-2.86 5.47l-70.61 40.77c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m491.93 426.23v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m544.65 390.73c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m539.23 391.99c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m533.48 395.3c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m527.74 398.62c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m522 401.93c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m495.27 421.01v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m488.49 453.63v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.77c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.55-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m491.93 449.98v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m544.65 414.47c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m539.23 415.73c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m533.48 419.04c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m527.74 422.36c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m522 425.67c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m495.27 444.75v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m488.49 477.37v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.55-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m491.93 473.72v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m544.65 438.22c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m539.23 439.47c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m533.48 442.78c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m527.74 446.1c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m522 449.42c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m495.27 468.5v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m488.49 501.11v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.77c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m491.93 497.46v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m544.65 461.96c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m539.23 463.21c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m533.48 466.53c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m527.74 469.84c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m522 473.16c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m495.27 492.24v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m488.49 524.86v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.77c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m491.93 521.2v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m544.65 485.7c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m538.86 485.73c1.7-0.98 3.07-0.19 3.07 1.78c0 1.96-1.38 4.35-3.07 5.33c-1.7 0.98-3.08 0.19-3.08-1.78c0-1.96 1.38-4.35 3.08-5.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m525.52 495.2c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m519.77 498.51c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m514.03 501.83c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m495.27 515.98v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m654.84 489.06v-175.94l69.95-18.31l12.88-7.44c2.96-1.71 8.12-1.49 11.54 0.48l12.02 6.94l37.31-0.02l-11.05 169.85c0.08 1.16-0.56 2.27-1.98 3.09l-69.8 52.67c-2.96 1.71-8.12 1.49-11.54-0.48l-46.52-26.86c-1.97-1.14-2.92-2.61-2.81-3.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m743.02 286.23c2.16 0.05 4.41 0.6 6.18 1.62l12.02 6.94l37.31-0.02v176.42c0.08 1.16-0.56 2.27-1.98 3.09l-80.85 46.1c-1.42 0.82-3.35 1.19-5.35 1.14l-0.83-177.52l33.51-57.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m714.96 520.74c-2.55 1.09-6.24 1.03-9.22-0.11v-178.73h9.22v178.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m704.17 343.54l-46.52-26.86c-3.41-1.97-3.78-4.95-0.83-6.66l80.85-46.1c2.96-1.71 8.12-1.49 11.54 0.48l46.52 26.86c3.41 1.97 3.78 4.95 0.83 6.66l-80.85 46.1c-2.96 1.71-8.12 1.49-11.54-0.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m657.65 313.41l46.52 26.86c3.41 1.97 8.58 2.19 11.54 0.48l80.85-46.1c0.66-0.38 1.14-0.83 1.48-1.31c1.02 1.63 0.56 3.41-1.48 4.58l-80.85 46.1c-2.96 1.71-8.12 1.49-11.54-0.48l-46.52-26.86c-2.65-1.53-3.46-3.67-2.3-5.35c0.46 0.75 1.23 1.46 2.3 2.08z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m708.02 325.11l-21.77-12.57c-1.6-0.92-1.77-2.32-0.39-3.12l53.83-31.2c1.38-0.8 3.8-0.7 5.4 0.22l21.77 12.57c1.6 0.92 1.77 2.32 0.39 3.12l-53.83 31.2c-1.38 0.8-3.8 0.7-5.4-0.22z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m741.73 295.5l-3.01-1.74c-0.22-0.13-0.24-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m731.31 301.5l-3.01-1.74c-0.22-0.13-0.25-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m720.89 307.49l-3.01-1.74c-0.22-0.13-0.25-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.24 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m710.47 313.48l-3.01-1.74c-0.22-0.13-0.24-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m767.24 294.13l-0.06 0.04c-0.11-0.08-0.2-0.15-0.32-0.22l-21.77-12.57c-1.6-0.92-4.01-1.02-5.4-0.22l-53.76 31.16c-1.28-0.91-1.34-2.16-0.06-2.89l53.83-31.2c1.38-0.8 3.8-0.7 5.4 0.22l21.77 12.57c1.6 0.92 1.77 2.32 0.39 3.12z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m695.09 378.88l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m662.97 341.77c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m685.88 366.99l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m676.49 361.57l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m695.09 457.96l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m662.97 420.85c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m685.88 446.08l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m676.49 440.66l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m695.09 497.51l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m662.97 460.4c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m685.88 485.62l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m676.49 480.2l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m695.09 418.42l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m662.97 381.31c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.52 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m685.88 406.53l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m676.49 401.11l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m718.73 365.51v-13.46c0-2.11 1.28-4.55 2.86-5.47l70.61-40.77c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m722.17 361.86v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m774.89 326.35c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m769.47 327.61c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m763.72 330.92c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m757.98 334.24c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m752.24 337.56c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m725.51 356.63v-3.54c0-0.67 0.41-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m718.73 389.25v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.77c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.55-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m722.17 385.6v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m774.89 350.1c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m769.47 351.35c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m763.72 354.67c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m757.98 357.98c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m752.24 361.3c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m725.51 380.38v-3.54c0-0.67 0.41-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m718.73 413v-13.46c0-2.11 1.28-4.55 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m722.17 409.34v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m774.89 373.84c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m769.47 375.09c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m763.72 378.41c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m757.98 381.72c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m752.24 385.04c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m725.51 404.12v-3.54c0-0.67 0.41-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m718.73 436.74v-13.46c0-2.11 1.28-4.55 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.55-2.86 5.47l-70.61 40.77c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m722.17 433.08v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m774.89 397.58c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m769.47 398.83c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m763.72 402.15c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m757.98 405.46c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m752.24 408.78c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m725.51 427.86v-3.54c0-0.67 0.41-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m718.73 460.48v-13.46c0-2.11 1.28-4.55 2.86-5.47l70.61-40.77c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.77c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m722.17 456.82v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m774.89 421.32c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m769.47 422.57c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m763.72 425.89c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m757.98 429.21c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m752.24 432.52c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m725.51 451.6v-3.54c0-0.67 0.41-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m718.73 484.22v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.77c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.55-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m722.17 480.57v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m774.89 445.06c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m769.47 446.32c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m763.72 449.63c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m757.98 452.95c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m752.24 456.26c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m725.51 475.34v-3.54c0-0.67 0.41-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m718.73 507.96v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.77c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.55-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m722.17 504.31v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m774.89 468.81c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m769.1 468.84c1.7-0.98 3.07-0.19 3.07 1.78c0 1.96-1.38 4.35-3.07 5.33c-1.7 0.98-3.07 0.19-3.07-1.78c0-1.96 1.38-4.35 3.07-5.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m755.76 478.3c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m750.01 481.62c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m744.27 484.93c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m725.51 499.08v-3.54c0-0.67 0.41-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m528.09 562.75v-175.94l69.95-18.31l12.88-7.44c2.96-1.71 8.12-1.49 11.54 0.48l12.02 6.94l37.31-0.02l-11.05 169.85c0.08 1.16-0.56 2.27-1.98 3.09l-69.8 52.67c-2.96 1.71-8.12 1.49-11.54-0.48l-46.52-26.86c-1.97-1.14-2.92-2.61-2.81-3.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m613.27 360.92c2.16 0.05 4.41 0.6 6.18 1.62l12.02 6.94l37.31-0.02v176.42c0.08 1.16-0.56 2.27-1.98 3.09l-80.85 46.1c-1.42 0.82-3.35 1.19-5.35 1.14l-0.83-177.52l33.51-57.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m585.21 595.43c-2.55 1.09-6.24 1.03-9.22-0.11v-178.73h9.22v178.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m577.41 418.24l-46.52-26.86c-3.41-1.97-3.78-4.95-0.83-6.66l80.85-46.1c2.96-1.71 8.12-1.49 11.54 0.48l46.52 26.86c3.41 1.97 3.78 4.95 0.83 6.66l-80.85 46.1c-2.96 1.71-8.12 1.49-11.54-0.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m527.9 388.11l46.52 26.86c3.41 1.97 8.58 2.19 11.54 0.48l80.85-46.1c0.66-0.38 1.14-0.83 1.48-1.31c1.02 1.63 0.56 3.41-1.48 4.58l-80.85 46.1c-2.96 1.71-8.12 1.49-11.54-0.48l-46.52-26.86c-2.65-1.53-3.46-3.67-2.3-5.35c0.46 0.75 1.23 1.46 2.3 2.08z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m578.26 399.81l-21.77-12.57c-1.6-0.92-1.77-2.32-0.39-3.12l53.83-31.2c1.38-0.8 3.8-0.7 5.4 0.22l21.77 12.57c1.6 0.92 1.77 2.32 0.39 3.12l-53.83 31.2c-1.38 0.8-3.8 0.7-5.4-0.22z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m611.98 370.2l-3.01-1.74c-0.22-0.13-0.25-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.24 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m601.56 376.19l-3.01-1.74c-0.22-0.13-0.25-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.24 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m591.13 382.18l-3.01-1.74c-0.22-0.13-0.25-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.24 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m580.71 388.18l-3.01-1.74c-0.22-0.13-0.25-0.32-0.05-0.43l3.12-1.8c0.19-0.11 0.53-0.1 0.75 0.03l3.01 1.74c0.22 0.13 0.25 0.32 0.05 0.43l-3.12 1.8c-0.19 0.11-0.53 0.1-0.75-0.03z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m637.49 368.83l-0.06 0.04c-0.11-0.08-0.2-0.15-0.32-0.22l-21.77-12.57c-1.6-0.92-4.01-1.02-5.4-0.22l-53.76 31.17c-1.28-0.91-1.34-2.16-0.06-2.89l53.83-31.2c1.38-0.8 3.8-0.7 5.4 0.22l21.77 12.57c1.6 0.92 1.77 2.32 0.39 3.12z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m565.33 453.57l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m533.21 416.46c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.51 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m556.13 441.69l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m546.74 436.27l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m565.33 532.66l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m533.21 495.55c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.51 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m556.13 520.77l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m546.74 515.35l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m565.33 572.2l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m533.21 535.09c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.51 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m556.13 560.32l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m546.74 554.9l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m565.33 493.12l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-2.3 1.4-3.35 3.12-2.36l30.6 17.52c1.72 0.99 3.12 3.66 3.12 5.96v10.94c0 2.3-1.4 3.35-3.12 2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m533.21 456.01c-0.48 0.45-0.78 1.23-0.78 2.28v10.94c0 2.3 1.4 4.96 3.12 5.96l30.6 17.52c0.55 0.32 1.06 0.41 1.51 0.33c-0.57 0.54-1.4 0.62-2.34 0.08l-30.6-17.52c-1.72-0.99-3.12-3.66-3.12-5.96v-10.94c0-1.56 0.65-2.53 1.6-2.69z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m556.13 481.23l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m546.74 475.81l-2.81-1.62c-0.38-0.22-0.68-0.8-0.68-1.3v-3c0-0.5 0.3-0.73 0.68-0.51l2.81 1.62c0.38 0.22 0.68 0.8 0.68 1.3v3c0 0.5-0.3 0.73-0.68 0.51z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m588.98 440.21v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m592.41 436.55v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m645.14 401.05c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m639.71 402.3c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m633.97 405.62c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m628.23 408.94c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m622.48 412.25c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m595.76 431.33v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m588.98 463.95v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.77c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m592.41 460.3v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m645.14 424.79c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m639.71 426.05c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m633.97 429.36c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m628.23 432.68c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m622.48 435.99c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m595.76 455.07v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m588.98 487.69v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m592.41 484.04v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m645.14 448.53c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m639.71 449.79c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m633.97 453.1c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m628.23 456.42c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m622.48 459.73c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m595.76 478.81v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m588.98 511.43v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.77c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m592.41 507.78v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m645.14 472.28c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m639.71 473.53c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m633.97 476.85c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m628.23 480.16c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m622.48 483.48c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m595.76 502.56v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m588.98 535.18v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m592.41 531.52v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m645.14 496.02c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m639.71 497.27c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m633.97 500.59c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m628.23 503.9c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m622.48 507.22c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m595.76 526.3v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m588.98 558.92v-13.46c0-2.11 1.28-4.55 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m592.41 555.26v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m645.14 519.76v0c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m639.71 521.01c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m633.97 524.33c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m628.23 527.64c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m622.48 530.96c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m595.76 550.04v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m588.98 582.66v-13.46c0-2.11 1.28-4.56 2.86-5.47l70.61-40.76c1.58-0.91 2.86 0.06 2.86 2.16v13.46c0 2.11-1.28 4.56-2.86 5.47l-70.61 40.76c-1.58 0.91-2.86-0.06-2.86-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m592.41 579v-10.12c0-1.07 0.65-2.31 1.45-2.77l66.55-38.42c0.8-0.46 1.45 0.03 1.45 1.1v10.12c0 1.07-0.65 2.31-1.45 2.77l-66.55 38.42c-0.8 0.46-1.45-0.03-1.45-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m645.14 543.5c0-1.04 0.63-2.24 1.41-2.69l9.93-5.73c0.78-0.45 1.41 0.03 1.41 1.07c0 1.04-0.63 2.24-1.41 2.69l-9.93 5.73c-0.78 0.45-1.41-0.03-1.41-1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m639.35 543.53c1.7-0.98 3.07-0.19 3.07 1.78c0 1.96-1.38 4.35-3.07 5.33c-1.7 0.98-3.08 0.19-3.08-1.78c0-1.96 1.38-4.35 3.08-5.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m626 553c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m620.26 556.32c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m614.52 559.63c0.9-0.52 1.63-0.1 1.63 0.94c0 1.04-0.73 2.3-1.63 2.82c-0.9 0.52-1.63 0.1-1.63-0.94c0-1.04 0.73-2.3 1.63-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m595.76 573.78v-3.54c0-0.67 0.4-1.44 0.9-1.73l3.35-1.93c0.5-0.29 0.9 0.02 0.9 0.68v3.54c0 0.67-0.41 1.44-0.9 1.73l-3.35 1.93c-0.5 0.29-0.9-0.02-0.9-0.68z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m323.43 269.04c-2.63 1.52-6.9 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m938.98 424.01c-2.63 1.52-6.9 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m705.11 163.9c-2.63 1.52-6.89 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m743.3 559.85c-2.63 1.52-6.89 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m296.78 764.71l-0.5-0.29l-174.17-100.97l74.57-43.05l0.5 0.29l174.17 100.97l-74.57 43.05zm-170.68-101.26l170.68 98.95l70.57-40.75l-170.69-98.95l-70.57 40.75z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m721.53 764.47l-59.49-34.35l91.42-52.78l59.49 34.35l-91.42 52.78zm-54.8-34.35l54.8 31.64l86.73-50.08l-54.8-31.64l-86.73 50.08z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m745.31 712.25l-1.11 5.59l-0.81 3.07l-6.45-4.06l0 0c-1.85-0.71-3.05-2.87-3.04-6.08l0.1-47.64l14.52-8.01l7.25 4.48l-7.34 36.96l-0.01 6.2c-0.01 3.22-1.23 6.74-3.1 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m748.38 720.77c-4.01 2.21-7.25-0.26-7.24-5.52l0.1-47.64l14.52-8.01l-0.1 47.64c-0.01 5.26-3.27 11.32-7.28 13.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m787.56 633.94c0 12.09-8.49 16.99-18.96 10.95c-10.47-6.05-18.96-20.75-18.96-32.84c0-12.09 8.49-16.99 18.96-10.95c10.47 6.05 18.96 20.75 18.96 32.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m782.19 646.11l-55.17 31.64l-29.66-44.55l57.48-33.2l27.35 46.11z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m754.69 662.76c-18.52 12.73-33.62 29.83-43.95 49.8l-2.83 5.48l-52.31-89.63l6.42 0.25c22.68 0.88 45.21-3.9 65.57-13.91c0.15-0.08 0.29-0.15 0.44-0.22c0.03-0.01 0.06-0.03 0.09-0.04l0.07-0.03l0.01 0.01c3.42-1.46 7.89-0.97 12.79 1.86c10.77 6.22 19.5 21.34 19.5 33.77c0 6.27-2.22 10.66-5.81 12.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m703.3 721.85l0.01 0l-0.2 0.12c-0.03 0.02-0.06 0.03-0.09 0.05l-5.65 3.3l0.97-1.43c-6.13 1.52-13.63 0.17-21.74-4.51c-20.66-11.93-37.41-40.94-37.41-64.79c0-9.34 2.57-16.5 6.93-21.05l-2.14 0.45l6.14-3.6c0.02-0.01 0.03-0.02 0.05-0.03l0.04-0.02l0 0c6.77-3.87 16.09-3.3 26.4 2.65c20.66 11.93 37.41 40.94 37.41 64.79c0 11.78-4.08 20.1-10.71 24.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m697.45 725.19l0.89-1.3c-6.13 1.52-13.63 0.17-21.74-4.51c-20.66-11.93-37.41-40.94-37.41-64.79c0-9.34 2.57-16.5 6.93-21.05l-1.9 0.4c0.31-0.22 0.62-0.44 0.94-0.64l0.94-0.55c6.74-3.7 15.96-3.07 26.12 2.8c20.66 11.93 37.41 40.94 37.41 64.79c0 12.63-4.69 21.28-12.18 24.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m708.39 701.06c0 23.86-16.75 33.52-37.41 21.6c-20.66-11.93-37.41-40.94-37.41-64.79c0-23.86 16.75-33.52 37.41-21.6c20.66 11.93 37.41 40.94 37.41 64.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m703.8 698.42c0 20.93-14.69 29.41-32.82 18.95c-18.13-10.46-32.82-35.91-32.82-56.84c0-20.93 14.69-29.41 32.82-18.95c18.13 10.46 32.82 35.91 32.82 56.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m693.27 720.15c-5.85 2.88-13.69 2.19-22.29-2.78c-18.13-10.46-32.82-35.91-32.82-56.84c0-11.83 4.7-19.69 12.06-22.39c-6.47 3.18-10.53 10.74-10.53 21.73c0 20.93 14.69 46.38 32.82 56.84c7.88 4.55 15.1 5.52 20.76 3.44z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m667.07 671.62l47.62-36.82l17.29 30l-55.89 22.93l-9.02-16.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m677.53 683.25c0 4.18-2.93 5.87-6.55 3.78c-3.62-2.09-6.55-7.17-6.55-11.35c0-4.18 2.93-5.87 6.55-3.78c3.62 2.09 6.55 7.17 6.55 11.35z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m737.64 703.16l-0.26-0.15c-0.95-0.55-1.73-2.02-1.73-3.28l-0.03-9.19c0-1.27 0.77-1.85 1.72-1.31l0.26 0.15c0.95 0.55 1.73 2.02 1.73 3.28l0.03 9.19c0 1.27-0.77 1.85-1.72 1.31z"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1048.21 337.12c-2.63 1.52-6.89 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1018.93 456.71l-172.85-99.47c-3.87-2.23-5.8-5.11-5.67-7.81l0 0l-0.04-11.99c2.36 2.6 4.1 4.51 5.22 5.74l83.31-48.24c5.93-3.44 16.31-3.02 23.17 0.93l172.85 99.47c0.33 0.19 0.64 0.39 0.95 0.59l4.7-5.5l0.03 12.26l-0.02-0.01c0.09 2.25-1.2 4.42-3.98 6.03l-84.49 48.93c-5.93 3.44-16.31 3.02-23.17-0.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1087.79 427.62l-4.87 2.81c-0.65 0.37-1.17-0.02-1.17-0.88c0-0.86 0.52-1.86 1.17-2.24l4.87-2.81c0.65-0.37 1.17 0.02 1.17 0.88c0 0.86-0.52 1.86-1.17 2.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1031.24 341.43l0.16 118.52c-4.36-0.09-8.89-1.18-12.47-3.24l-172.85-99.47c-3.87-2.23-5.8-5.11-5.67-7.81l0 0l-0.04-11.99c2.36 2.6 4.1 4.51 5.22 5.74l83.31-48.24c5.93-3.44 16.31-3.02 23.17 0.93l79.18 45.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m844.37 331.54l84.49-48.93c5.93-3.44 16.31-3.02 23.17 0.93l172.85 99.47c6.86 3.95 7.62 9.94 1.68 13.37l-84.49 48.93c-5.93 3.44-16.31 3.02-23.17-0.93l-172.85-99.47c-6.86-3.95-7.62-9.94-1.68-13.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1018.96 445.69l-172.85-99.47c-3.94-2.27-5.86-5.21-5.66-7.96c0.39 2.35 2.27 4.74 5.59 6.65l172.85 99.47c6.86 3.95 17.24 4.36 23.17 0.93l84.49-48.93c2.52-1.46 3.82-3.38 3.97-5.41c0.42 2.5-0.85 4.95-3.91 6.72l-84.49 48.93c-5.93 3.44-16.31 3.02-23.17-0.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m850.88 333.47l81.19-47.01c4.41-2.55 12.12-2.25 17.22 0.69l170.39 98.06c5.1 2.94 5.66 7.39 1.25 9.94l-81.19 47.01c-4.41 2.55-12.12 2.25-17.22-0.69l-170.39-98.06c-5.1-2.94-5.66-7.39-1.25-9.94z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1015.63 415.63l57.29-33.08l3.66 2.11l-57.29 33.08l-3.66-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1055.49 405.98l29.01-16.75l3.66 2.11l-29.01 16.75l-3.66-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1041.41 414.11l9.41-5.43l3.66 2.11l-9.41 5.43l-3.66-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1027.21 422.31l9.41-5.43l3.66 2.11l-9.41 5.43l-3.66-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1055.17 399.49l23.54-13.59l3.66 2.11l-23.54 13.59l-3.66-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1026.43 416.08l23.54-13.59l3.66 2.11l-23.54 13.59l-3.66-2.11z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1047.51 386.67c1.18-0.68 3.09-0.68 4.27 0c1.18 0.68 1.18 1.78 0 2.46c-1.18 0.68-3.09 0.68-4.27 0c-1.18-0.68-1.18-1.78 0-2.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1041.14 390.35c1.18-0.68 3.09-0.68 4.27 0c1.18 0.68 1.18 1.78 0 2.46c-1.18 0.68-3.09 0.68-4.27 0c-1.18-0.68-1.18-1.78 0-2.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1034.76 394.03c1.18-0.68 3.09-0.68 4.27 0c1.18 0.68 1.18 1.78 0 2.46c-1.18 0.68-3.09 0.68-4.27 0c-1.18-0.68-1.18-1.78 0-2.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1028.39 397.71c1.18-0.68 3.09-0.68 4.27 0c1.18 0.68 1.18 1.78 0 2.46c-1.18 0.68-3.09 0.68-4.27 0c-1.18-0.68-1.18-1.78 0-2.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1022.02 401.39c1.18-0.68 3.09-0.68 4.27 0c1.18 0.68 1.18 1.78 0 2.46c-1.18 0.68-3.09 0.68-4.27 0c-1.18-0.68-1.18-1.78 0-2.46z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m890.13 331.66l9.65-5.57l3.75 2.16l-9.65 5.57l-3.75-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m876.7 339.42l9.65-5.57l3.75 2.16l-9.65 5.57l-3.75-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m933.22 306.56l9.65-5.57l3.75 2.16l-9.65 5.57l-3.75-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m892.28 337.28l13.43-7.75l3.75 2.16l-13.43 7.75l-3.75-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m882.64 342.85l5.89-3.4l3.75 2.16l-5.89 3.4l-3.75-2.16z"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m229.15 424.23l-0.51-0.29l-110.17-63.54l33.69-19.45l0.51 0.29l110.18 63.54l-33.69 19.45zm-106.63-63.83l106.63 61.49l29.64-17.11l-106.63-61.49l-29.64 17.11z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m263.88 299.19l-0.51-0.3l-182.36-106.7l107.9-62.07l1.01 1.75l-104.87 60.33l178.84 104.64l54.28-31.43l1.02 1.75l-55.3 32.02z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m165.81 369.29c-0.55 0-1-0.45-1-1v-56.92c0-0.55 0.45-1 1-1c0.55 0 1 0.45 1 1v56.92c0 0.55-0.45 1-1 1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m170.75 329.13h-9.89v-21.34h9.89v21.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m169.3 331.15c-1.93 1.11-5.06 1.11-6.99 0c-1.93-1.11-1.93-2.92 0-4.04c1.93-1.11 5.06-1.11 6.99 0c1.93 1.11 1.93 2.92 0 4.04z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m173.82 311.52h-16.02v-33.47h16.02v33.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m170.75 311.3v7.22c-2.9 1.33-6.99 1.33-9.89 0v-7.22c2.9-1.33 6.99-1.33 9.89 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m171.47 314.79c-3.13 1.81-8.2 1.81-11.33 0c-3.13-1.81-3.13-4.74 0-6.54c3.13-1.81 8.2-1.81 11.33 0c3.13 1.81 3.13 4.74 0 6.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m221.32 400.52c-0.55 0-1-0.45-1-1v-56.92c0-0.55 0.45-1 1-1c0.55 0 1 0.45 1 1v56.92c0 0.55-0.45 1-1 1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m226.26 360.36h-9.89v-21.34h9.89v21.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m224.81 362.38c-1.93 1.11-5.06 1.11-6.99 0c-1.93-1.11-1.93-2.92 0-4.04c1.93-1.11 5.06-1.11 6.99 0c1.93 1.11 1.93 2.92 0 4.04z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m229.33 342.75h-16.02v-33.47h16.02v33.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m226.26 342.53v7.22c-2.9 1.33-6.99 1.33-9.89 0v-7.22c2.9-1.33 6.99-1.33 9.89 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m226.98 346.02c-3.13 1.81-8.2 1.81-11.33 0c-3.13-1.81-3.13-4.74 0-6.54c3.13-1.81 8.2-1.81 11.33 0c3.13 1.81 3.13 4.74 0 6.54z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m270.92 335.41l5.38-8.79l20.46 25.54l-21.49 12.65l-4.36-29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m119.27 224.65l34.29-19.73c-0.86 13.13-1.29 19.7-1.29 19.73c0 0.03-6.57 2.06-19.7 6.1l-13.3-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m302.95 338.2c0 13.85-9.72 19.46-21.71 12.53l-107.59-76.82c-15.97-9.22-28.91-31.64-28.91-50.08c0-10 3.81-16.76 9.84-19.4l-6.72-5.31l20.22-11.94c0.16-0.1 0.33-0.19 0.49-0.28l0.32-0.18l0 0.02c6.5-3.43 15.32-2.77 25.03 2.84c18.59 10.74 33.91 35.76 35.97 57.79c3.91 0.3 8.22 1.7 12.76 4.32c15.08 8.7 27.72 28 31.17 46.17c2.32 0.36 4.81 1.24 7.42 2.75c11.99 6.92 21.71 23.76 21.71 37.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m154.59 204.43l-6.72-5.31l20.22-11.94c0.16-0.1 0.33-0.19 0.49-0.28l0.32-0.18l0 0.02c6.1-3.22 14.24-2.84 23.25 1.86l-46.41 27.12c1.5-5.57 4.63-9.44 8.84-11.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m196.11 275.08l43.07-25.19c1.14 0.52 2.3 1.11 3.47 1.78c8.85 5.11 16.85 13.89 22.66 23.93l-33.86 19.87l-35.33-20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m184.27 185.52c3.08 0.79 6.31 2.12 9.66 4.06c2.12 1.22 4.19 2.64 6.21 4.21l-27.64 16.28l-15.09-8.71l26.86-15.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m268.48 281.68l-24.53 14.49l-9.4-10.48l27.03-15.92c2.64 3.75 4.97 7.77 6.91 11.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m281.73 350.7c0 13.85-9.72 19.46-21.71 12.53l-120.6-69.63c-15.97-9.22-28.91-31.64-28.91-50.08c0-17.32 11.43-24.96 26.05-18.18c-0.04-0.79-0.06-1.58-0.06-2.37c0-23.09 16.21-32.45 36.21-20.9c18.6 10.74 33.91 35.76 35.97 57.79c3.91 0.3 8.22 1.7 12.76 4.32c15.08 8.7 27.72 28 31.17 46.17c2.32 0.36 4.81 1.24 7.42 2.75c11.99 6.92 21.71 23.76 21.71 37.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m117.11 226.15c4.36-5.04 11.3-6.41 19.38-3.27c0 0.03 0 0.06 0 0.1c0 0.78 0.02 1.57 0.06 2.37c-7.82-3.63-14.7-3.09-19.44 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m283.49 348.98c0 6.22-1.98 10.77-5.23 13.27c2.18-2.65 3.46-6.55 3.46-11.55c0-13.85-9.72-30.68-21.71-37.6c-2.61-1.51-5.1-2.39-7.42-2.75c-3.46-18.17-16.1-37.47-31.17-46.17c-4.53-2.62-8.85-4.02-12.76-4.32c-2.06-22.02-17.37-47.05-35.97-57.79c-11.4-6.58-21.56-6.36-28.2-0.69c6.51-7.3 17.5-8.22 29.96-1.03c18.59 10.74 33.91 35.76 35.97 57.79c3.91 0.3 8.22 1.7 12.76 4.32c15.08 8.7 27.72 28 31.17 46.17c2.32 0.36 4.81 1.24 7.42 2.75c11.99 6.92 21.71 23.76 21.71 37.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m134 230.85l9.07 4.2l-0.46-9.98c-0.03-0.7-0.05-1.4-0.05-2.09c0-8.91 2.69-15.37 7.57-18.19c4.88-2.82 11.83-1.92 19.54 2.54c16.6 9.58 31.07 32.91 32.96 53.1l0.48 5.09l5.09 0.39c3.13 0.24 6.56 1.43 10.19 3.52c13.18 7.61 25.06 25.3 28.25 42.05l0.8 4.19l4.22 0.66c1.68 0.26 3.47 0.94 5.33 2.01c10.13 5.85 18.68 20.66 18.68 32.35c0 4.38-1.21 7.59-3.33 8.81c-2.11 1.22-5.5 0.67-9.29-1.52l-120.6-69.63c-14.03-8.1-25.88-28.63-25.88-44.83c0-6.36 1.87-11.2 5.14-13.29c1.35-0.86 2.97-1.29 4.81-1.29c2.23 0 4.77 0.63 7.49 1.89z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m194.24 302.46l3.13 2.37l-3.18 1.6l0.05-3.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m184.63 263.46l3.09-1.56l0.06 1.62l-3.14-0.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m200.28 288.87l6.2 5.9l-3.22 1.62l-2.98-7.52z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m196.44 304.73l-15.06-8.87c-0.76-0.45-1.38-1.58-1.38-2.53l0.05-17.44l17.83 10.5l-0.05 17.44c0 0.95-0.62 1.35-1.39 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m190.34 263.48l16.15 29.56c0.69 1.25 0.12 2.25-0.93 1.63l-16.62-9.79l-16.62-9.79c-1.05-0.62-1.61-2.27-0.92-2.72l16.27-10.47c0.7-0.45 1.95 0.28 2.65 1.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m193.21 306.36l-15.06-8.87c-0.76-0.45-1.38-1.58-1.38-2.53l0.05-17.44l17.83 10.5l-0.05 17.44c0 0.95-0.62 1.35-1.39 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m187.11 265.1l16.15 29.56c0.69 1.25 0.12 2.25-0.93 1.63l-16.62-9.79l-16.61-9.79c-1.05-0.62-1.61-2.27-0.92-2.72l16.27-10.47c0.7-0.45 1.95 0.28 2.65 1.56z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m164.29 325.43c0 0.98-0.69 1.38-1.54 0.89c-0.85-0.49-1.54-1.68-1.54-2.67c0-0.98 0.69-1.38 1.54-0.89c0.85 0.49 1.54 1.68 1.54 2.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m219.93 357.12c0 0.98-0.69 1.38-1.54 0.89c-0.85-0.49-1.54-1.68-1.54-2.67c0-0.98 0.69-1.38 1.54-0.89c0.85 0.49 1.54 1.68 1.54 2.67z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m250.21 416.68c-2.63 1.52-6.9 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.9-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m537.17 754.99l-50.33-29.06l50.33-29.06l50.33 29.06l-50.33 29.06zm-46.28-29.06l46.28 26.72l46.28-26.72l-46.28-26.72l-46.28 26.72z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m579.3 718.16l-37.18 21.47c-2.73 1.58-6.86 1.75-9.22 0.38l-38.51-22.23c-1.14-0.66-1.65-1.55-1.58-2.47v-13.67l29.82 0.02l9.61-5.55c2.73-1.58 6.86-1.75 9.22-0.38l10.3 5.95l29.8 0.02v13.29c0.09 1.1-0.67 2.27-2.25 3.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m537.18 740.92c-1.6 0.04-3.14-0.26-4.28-0.91l-38.51-22.23c-1.14-0.66-1.65-1.55-1.58-2.47v-13.67l29.82 0.02l9.61-5.55c1.42-0.82 3.21-1.25 4.94-1.3v46.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m496.18 718.81l-1.79-1.03c-1.14-0.66-1.65-1.55-1.58-2.47v-13.67l3.38 0v17.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m533.49 724.7h7.37v15.52c-2.38 0.91-5.33 0.96-7.37 0.08v-15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m532.9 726.39l-38.51-22.23c-2.36-1.36-2.07-3.75 0.66-5.32l37.18-21.47c2.73-1.58 6.86-1.75 9.22-0.38l38.51 22.23c2.36 1.36 2.07 3.75-0.66 5.32l-37.18 21.47c-2.73 1.58-6.86 1.75-9.22 0.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m581.14 700.26c0.92 1.34 0.28 3.05-1.84 4.28l-37.18 21.47c-2.73 1.58-6.86 1.75-9.22 0.38l-38.51-22.23c-1.62-0.94-1.99-2.35-1.18-3.66c0.26 0.39 0.65 0.74 1.18 1.05l38.51 22.23c2.36 1.36 6.49 1.19 9.22-0.38l37.18-21.47c0.86-0.49 1.47-1.07 1.84-1.66z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m567.38 718.48c0 0.99-0.7 2.2-1.56 2.69c-0.86 0.5-1.56 0.09-1.56-0.9c0-0.99 0.7-2.2 1.56-2.69c0.86-0.5 1.56-0.09 1.56 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m572.39 715.59c0 0.99-0.7 2.2-1.56 2.69c-0.86 0.5-1.56 0.09-1.56-0.9c0-0.99 0.7-2.2 1.56-2.69c0.86-0.5 1.56-0.09 1.56 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m577.39 712.7c0 0.99-0.7 2.2-1.56 2.69c-0.86 0.5-1.56 0.09-1.56-0.9c0-0.99 0.7-2.2 1.56-2.69c0.86-0.5 1.56-0.09 1.56 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m535.17 712.61l-18.02-10.4c-1.11-0.64-0.97-1.75 0.31-2.49l17.4-10.05c1.28-0.74 3.21-0.82 4.32-0.18l18.02 10.4c1.11 0.64 0.97 1.75-0.31 2.49l-17.4 10.05c-1.28 0.74-3.21 0.82-4.32 0.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m536.9 703.89l-2.49-1.44c-0.15-0.09-0.13-0.24 0.04-0.34l2.41-1.39c0.18-0.1 0.44-0.11 0.6-0.02l2.49 1.44c0.15 0.09 0.13 0.24-0.04 0.34l-2.41 1.39c-0.18 0.1-0.44 0.11-0.6 0.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m517.46 699.71l17.4-10.05c1.28-0.74 3.21-0.82 4.32-0.18l18.02 10.4c1.02 0.59 0.97 1.58-0.05 2.31l-17.97-10.38c-1.11-0.64-3.04-0.56-4.32 0.18l-17.4 10.05c-0.1 0.06-0.17 0.12-0.26 0.18l-0.05-0.03c-1.11-0.64-0.97-1.75 0.31-2.49z"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m518.19 742.68c-2.63 1.52-6.9 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m213.16 146.07l-50.33-29.06l50.33-29.06l50.33 29.06l-50.33 29.06zm-46.28-29.06l46.28 26.72l46.28-26.72l-46.28-26.72l-46.28 26.72z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m255.29 109.23l-37.18 21.47c-2.73 1.58-6.86 1.75-9.22 0.38l-38.51-22.23c-1.14-0.66-1.65-1.55-1.58-2.47v-13.67l29.82 0.02l9.61-5.55c2.73-1.58 6.86-1.75 9.22-0.38l10.3 5.95l29.79 0.02v13.29c0.09 1.1-0.67 2.27-2.25 3.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m213.16 132c-1.6 0.04-3.14-0.26-4.28-0.91l-38.51-22.23c-1.14-0.66-1.65-1.55-1.58-2.47v-13.67l29.82 0.02l9.61-5.55c1.42-0.82 3.21-1.25 4.94-1.3v46.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m172.17 109.88l-1.79-1.03c-1.14-0.66-1.65-1.55-1.58-2.47v-13.67l3.38 0v17.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m209.48 115.77h7.37v15.52c-2.38 0.91-5.33 0.96-7.37 0.08v-15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m208.89 117.47l-38.51-22.23c-2.36-1.36-2.07-3.75 0.66-5.32l37.18-21.47c2.73-1.58 6.86-1.75 9.22-0.38l38.51 22.23c2.36 1.36 2.07 3.75-0.66 5.32l-37.18 21.47c-2.73 1.58-6.86 1.75-9.22 0.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m257.13 91.34c0.92 1.34 0.28 3.05-1.84 4.28l-37.18 21.47c-2.73 1.58-6.86 1.75-9.22 0.38l-38.51-22.23c-1.62-0.94-1.99-2.35-1.18-3.66c0.27 0.39 0.65 0.74 1.18 1.05l38.51 22.23c2.36 1.36 6.49 1.19 9.22-0.38l37.18-21.47c0.85-0.49 1.47-1.07 1.84-1.66z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m243.37 109.56c0 0.99-0.7 2.2-1.56 2.69c-0.86 0.5-1.56 0.09-1.56-0.9c0-0.99 0.7-2.2 1.56-2.69c0.86-0.5 1.56-0.09 1.56 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m248.38 106.67c0 0.99-0.7 2.2-1.56 2.69c-0.86 0.5-1.56 0.09-1.56-0.9c0-0.99 0.7-2.2 1.56-2.69c0.86-0.5 1.56-0.09 1.56 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m253.38 103.78c0 0.99-0.7 2.2-1.56 2.69c-0.86 0.5-1.56 0.09-1.56-0.9c0-0.99 0.7-2.2 1.56-2.69c0.86-0.5 1.56-0.09 1.56 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m211.16 103.68l-18.02-10.4c-1.11-0.64-0.97-1.75 0.31-2.49l17.4-10.05c1.28-0.74 3.21-0.82 4.31-0.18l18.02 10.4c1.11 0.64 0.97 1.75-0.31 2.49l-17.4 10.05c-1.28 0.74-3.21 0.82-4.32 0.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m212.89 94.97l-2.49-1.44c-0.15-0.09-0.13-0.24 0.04-0.34l2.41-1.39c0.18-0.1 0.44-0.11 0.6-0.02l2.49 1.44c0.15 0.09 0.13 0.24-0.04 0.34l-2.41 1.39c-0.18 0.1-0.44 0.11-0.6 0.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m193.45 90.79l17.4-10.05c1.28-0.74 3.21-0.82 4.31-0.18l18.02 10.4c1.02 0.59 0.97 1.58-0.05 2.31l-17.97-10.37c-1.11-0.64-3.04-0.56-4.31 0.18l-17.4 10.05c-0.1 0.06-0.17 0.12-0.26 0.18l-0.05-0.03c-1.11-0.64-0.97-1.75 0.31-2.49z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m194.18 133.75c-2.63 1.52-6.89 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m1041.47 158.08l-58.7-33.75l74.3-42.9l58.7 33.75l-74.3 42.9zm-54.64-33.75l54.64 31.42l70.25-40.56l-54.64-31.42l-70.25 40.56z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1035.35 142.01l-35.04-20.19c-1.5-0.87-2.26-1.97-2.28-3.02l-0.02 0.02l0-14.36l4.03 2.32l51.96-30.06c2.42-1.4 6.64-1.23 9.43 0.38l34.32 19.78c0.75-0.62 1.76-1.47 3.02-2.54l0.01 14.3l-0.03-0.02c-0.02 0.87-0.52 1.7-1.6 2.32l-54.37 31.45c-2.42 1.4-6.64 1.23-9.43-0.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1100.77 94.34l0.01 14.3l-0.03-0.02c-0.02 0.87-0.52 1.7-1.6 2.32l-54.37 31.45c-1.15 0.66-2.71 0.96-4.33 0.93v-58.78l13.54-7.83c2.42-1.4 6.64-1.23 9.43 0.38l34.32 19.78c0.75-0.62 1.76-1.47 3.02-2.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m999.62 101.96l54.37-31.45c2.42-1.4 6.64-1.23 9.43 0.38l35.04 20.19c2.79 1.61 3.1 4.05 0.68 5.44l-54.37 31.45c-2.42 1.4-6.64 1.23-9.43-0.38l-35.04-20.19c-2.79-1.61-3.1-4.05-0.68-5.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1035.22 129.06l-35.04-20.19c-1.97-1.14-2.67-2.68-2.09-3.98c0.22 0.89 0.95 1.79 2.21 2.52l35.04 20.19c2.79 1.61 7.01 1.78 9.43 0.38l54.37-31.45c0.71-0.41 1.16-0.92 1.4-1.46c0.27 1.08-0.21 2.16-1.53 2.93l-54.37 31.45c-2.42 1.4-6.64 1.23-9.43-0.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1056.93 93.32c-2.03-1.17-2.03-3.07 0-4.24c2.03-1.17 5.31-1.17 7.34-0.01c2.03 1.17 2.03 3.07 0 4.24c-2.03 1.17-5.31 1.17-7.34 0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1045.82 99.75c-2.03-1.17-2.03-3.07 0-4.24c2.03-1.17 5.31-1.17 7.34-0.01c2.03 1.17 2.03 3.07 0 4.24c-2.03 1.17-5.31 1.17-7.34 0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1034.71 106.18c-2.03-1.17-2.03-3.07 0-4.24c2.03-1.17 5.31-1.17 7.34-0.01c2.03 1.17 2.03 3.07 0 4.24c-2.03 1.17-5.31 1.17-7.34 0.01z"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m784.64 696.64c-2.63 1.52-6.9 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.9-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m296.58 663.09l-1.01-1.75l161.99-93.53l1.01 1.75l-161.99 93.53z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m275.11 707.56c-13.87 8.01-36.35 8.01-50.22 0c-6.96-4.02-10.42-9.29-10.4-14.55h0v-6.28h1.88c1.69-2.91 4.5-5.65 8.52-7.97c13.87-8.01 36.35-8.01 50.22 0c4.01 2.32 6.83 5.06 8.52 7.97h1.88v6.33c0 5.25-3.47 10.5-10.4 14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m283.63 686.73h1.88v6.33c0 5.25-3.47 10.5-10.4 14.5c-12.42 7.17-31.75 7.9-45.61 2.22v-33.24c13.86-5.68 33.19-4.95 45.61 2.22c4.01 2.32 6.83 5.06 8.52 7.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m275.11 701.23c-13.87 8.01-36.35 8.01-50.22 0c-13.87-8.01-13.87-20.99 0-29c13.87-8.01 36.35-8.01 50.22 0c13.87 8.01 13.87 20.99 0 29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m285.46 687.38c0.3 5.46-3.13 10.98-10.35 15.15c-13.87 8.01-36.35 8.01-50.22 0c-7.22-4.17-10.65-9.69-10.35-15.15c0.28 5.03 3.7 10.01 10.35 13.85c13.87 8.01 36.35 8.01 50.22 0c6.65-3.84 10.07-8.82 10.35-13.85z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m272.75 687.16c-1.49 0.87-3.76 0.97-5.06 0.23l-21.64-12.39c-0.58-0.33-0.87-0.78-0.88-1.25l0 0l-0.02-44.49l28.79 12.1l0.04 44.03c0.01 0.09 0.01 0.17 0 0.26l0 0h0c-0.06 0.53-0.48 1.07-1.22 1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m249.22 643.16l24.73 14.28l0.02 21.98l-28.8-16.63l-0.01-17.28l4.06-2.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m273.94 641.36l0.04 44.03c0.01 0.09 0.01 0.17 0 0.26v0c-0.06 0.53-0.48 1.07-1.22 1.51c-0.71 0.41-1.6 0.65-2.48 0.71l-0.12-48.1l3.78 1.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m272.71 642.91c-1.49 0.87-3.76 0.97-5.06 0.23l-21.64-12.39c-1.3-0.74-1.14-2.05 0.35-2.92c1.49-0.87 3.76-0.97 5.06-0.23l21.64 12.39c1.3 0.74 1.14 2.05-0.35 2.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m267.68 643.42l-21.64-12.39c-0.6-0.34-0.88-0.8-0.88-1.29c0.09 0.38 0.37 0.73 0.85 1l21.64 12.39c1.3 0.74 3.56 0.64 5.06-0.23l0 0c0.81-0.47 1.22-1.07 1.23-1.63c0.15 0.65-0.26 1.37-1.2 1.92h0c-1.49 0.87-3.76 0.97-5.06 0.23z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m379.92 568.25v145.53c0 3.14-1.05 5.35-2.71 6.3l0.01 0l-6.49 3.75l1.08-4.35l-210.45-121.5c-4.3-2.48-7.79-9.15-7.79-14.88v-145.53c0-0.69 0.05-1.33 0.15-1.93l-4.02-0.57l6.58-3.82l0 0.01c1.36-0.78 3.13-0.7 5.07 0.41l210.77 121.69c4.3 2.48 7.79 9.15 7.79 14.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m370.73 723.83l1.08-4.35l-134.7-77.77l140.89-81.34c1.18 2.5 1.92 5.28 1.92 7.87v145.53c0 3.14-1.05 5.35-2.71 6.3l0.01 0l-6.49 3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m365.44 723.54l-210.77-121.69c-4.3-2.48-7.79-9.15-7.79-14.88v-145.53c0-5.74 3.49-8.37 7.79-5.89l210.77 121.69c4.3 2.48 7.79 9.15 7.79 14.88v145.53c0 5.74-3.49 8.37-7.79 5.89z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m374.28 571.78v145.53c0 3.89-1.61 6.35-3.99 6.76c1.79-0.87 2.95-3.13 2.95-6.42v-145.53c0-5.74-3.49-12.4-7.79-14.88l-210.77-121.69c-1.38-0.8-2.67-1.06-3.8-0.87c1.33-0.64 3.01-0.52 4.84 0.54l210.77 121.69c4.3 2.48 7.79 9.15 7.79 14.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m366.1 718.72l-212.09-122.45c-1.52-0.88-2.76-3.24-2.76-5.27v-148.55c0-2.03 1.23-2.96 2.76-2.08l212.09 122.45c1.52 0.88 2.76 3.24 2.76 5.27v148.55c0 2.03-1.23 2.96-2.76 2.08z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m252.37 573.28l-13.79-7.96c-1.22-0.7-2.21-2.6-2.21-4.22v-15.14c0-1.63 0.99-2.38 2.21-1.67l13.79 7.96c1.22 0.7 2.21 2.6 2.21 4.22v15.14c0 1.63-0.99 2.38-2.21 1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m276.43 587.18l-13.79-7.96c-1.22-0.7-2.21-2.6-2.21-4.22v-15.14c0-1.63 0.99-2.38 2.21-1.67l13.79 7.96c1.22 0.7 2.21 2.6 2.21 4.22v15.14c0 1.63-0.99 2.38-2.21 1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m252.37 600.18l-13.79-7.96c-1.22-0.7-2.21-2.6-2.21-4.22v-15.14c0-1.63 0.99-2.38 2.21-1.67l13.79 7.96c1.22 0.7 2.21 2.6 2.21 4.22v15.14c0 1.63-0.99 2.38-2.21 1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m276.43 614.07l-13.79-7.96c-1.22-0.7-2.21-2.6-2.21-4.22v-15.14c0-1.63 0.99-2.38 2.21-1.67l13.79 7.96c1.22 0.7 2.21 2.6 2.21 4.22v15.14c0 1.63-0.99 2.38-2.21 1.67z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m442.37 130.76l-13.79-7.96c-1.22-0.7-1.95-2.45-1.63-3.9l3-13.48c0.32-1.45 1.57-2.05 2.79-1.35l13.79 7.96c1.22 0.7 1.95 2.45 1.63 3.9l-3 13.48c-0.32 1.45-1.57 2.05-2.8 1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m466.43 144.65l-13.79-7.96c-1.22-0.7-1.95-2.45-1.63-3.9l3-13.48c0.32-1.45 1.57-2.05 2.79-1.35l13.79 7.96c1.22 0.7 1.95 2.45 1.63 3.9l-3 13.48c-0.32 1.45-1.57 2.05-2.79 1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m437.04 154.7l-13.79-7.96c-1.22-0.7-1.95-2.45-1.63-3.9l3-13.48c0.32-1.45 1.57-2.05 2.79-1.35l13.79 7.96c1.22 0.7 1.95 2.45 1.63 3.9l-3 13.48c-0.32 1.45-1.57 2.05-2.79 1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m461.1 168.6l-13.79-7.96c-1.22-0.7-1.95-2.45-1.63-3.9l3-13.48c0.32-1.45 1.57-2.05 2.79-1.35l13.79 7.96c1.22 0.7 1.95 2.45 1.63 3.9l-3 13.48c-0.32 1.45-1.57 2.05-2.8 1.35z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m985.69 358.37l11.04-6.45c0.98-0.57 2.69-0.51 3.82 0.14l10.55 6.02c1.13 0.65 1.26 1.64 0.29 2.21l-11.04 6.45c-0.98 0.57-2.69 0.51-3.82-0.14l-10.55-6.02c-1.13-0.65-1.26-1.64-0.28-2.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m966.44 369.61l11.04-6.44c0.98-0.57 2.69-0.51 3.82 0.14l10.55 6.02c1.13 0.65 1.26 1.64 0.29 2.21l-11.04 6.44c-0.98 0.57-2.69 0.51-3.82-0.14l-10.55-6.02c-1.13-0.65-1.26-1.64-0.29-2.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m966.95 347.67l11.04-6.44c0.98-0.57 2.69-0.51 3.82 0.14l10.55 6.02c1.13 0.65 1.26 1.64 0.29 2.21l-11.04 6.44c-0.98 0.57-2.69 0.51-3.82-0.14l-10.55-6.02c-1.13-0.65-1.26-1.64-0.29-2.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m947.69 358.91l11.04-6.44c0.98-0.57 2.69-0.51 3.82 0.14l10.55 6.02c1.13 0.65 1.26 1.64 0.29 2.21l-11.04 6.44c-0.98 0.57-2.69 0.51-3.82-0.14l-10.55-6.02c-1.13-0.65-1.26-1.64-0.29-2.21z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m916.97 266.64l-151.26-87.25l69.8-39.9l151.26 87.25l-69.8 39.9zm-147.19-87.25l147.19 84.91l65.73-37.57l-147.19-84.91l-65.73 37.57z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m952.84 125.05v95.13c0 2.58-0.8 4.44-2.08 5.37l0 0l-0.07 0.04c-0.15 0.11-0.31 0.2-0.48 0.28l-36.61 21.2l-1.49-41.22l-72.86-42.06c-3.8-2.2-6.89-8.09-6.89-13.16v-58.56l-34.66-20.7l36.89-21.35l0 0.01c1.23-0.79 2.86-0.78 4.65 0.26l106.7 61.6c3.8 2.2 6.89 8.09 6.89 13.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m883.76 157.47l67.58-39.01c0.94 2.11 1.51 4.43 1.51 6.6v95.13c0 2.58-0.8 4.44-2.08 5.37l0 0l-0.07 0.04c-0.15 0.11-0.31 0.2-0.48 0.28l-36.61 21.2l-1.49-41.22l-28.35-16.37v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m908.9 246.83l-106.7-61.6c-3.8-2.2-6.89-8.09-6.89-13.16v-95.13c0-5.07 3.08-7.4 6.89-5.21l106.7 61.6c3.8 2.2 6.89 8.09 6.89 13.16v95.13c0 5.07-3.08 7.4-6.89 5.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m917.27 145.65v95.13c0 3.27-1.29 5.38-3.22 5.89c1.07-1 1.74-2.71 1.74-5.04v-95.13c0-5.07-3.08-10.96-6.89-13.16l-106.7-61.6c-1.35-0.78-2.6-0.96-3.66-0.68c1.26-1.18 3.09-1.35 5.14-0.16l106.7 61.6c3.8 2.2 6.89 8.09 6.89 13.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m920.7 143.63v95.13c0 2.94-1.04 4.95-2.66 5.7c1.07-1 1.72-2.74 1.72-5.07v-95.13c0-5.07-3.08-10.96-6.89-13.16l-106.7-61.6c-1.6-0.92-3.06-1.04-4.23-0.5c1.26-1.18 3.1-1.33 5.16-0.14l106.7 61.6c3.8 2.2 6.89 8.09 6.89 13.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m905.79 241.72l-100.48-58.01c-3.58-2.07-6.49-7.62-6.49-12.39v-89.58c0-4.78 2.9-6.97 6.49-4.9l100.48 58.01c3.58 2.07 6.49 7.62 6.49 12.39v89.58c0 4.78-2.9 6.97-6.49 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m812.74 96.45c0 1.37-0.96 1.93-2.16 1.24c-1.19-0.69-2.16-2.36-2.16-3.73c0-1.37 0.96-1.93 2.16-1.24c1.19 0.69 2.16 2.36 2.16 3.73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m839.08 171.27l-26.01-15.02c-1.37-0.79-2.48-2.92-2.48-4.74v-29.15c0-1.83 1.11-2.67 2.48-1.88l26.01 15.02c1.37 0.79 2.48 2.92 2.48 4.74v29.15c0 1.83-1.11 2.67-2.48 1.88z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m820.5 152.9c-0.36 0.28-0.87 0.23-1.54-0.16c-0.67-0.38-1.18-0.92-1.53-1.62c-0.36-0.69-0.53-1.45-0.53-2.26v-4.04c0-0.84 0.17-1.4 0.52-1.68c0.34-0.28 0.86-0.23 1.55 0.17c0.69 0.4 1.2 0.94 1.55 1.62c0.35 0.68 0.52 1.44 0.52 2.28v4.04c0 0.81-0.18 1.36-0.53 1.64zm-1.54-1.51c0.46 0.27 0.69-0.05 0.69-0.95v-3.99c0-0.12 0-0.23-0.01-0.33c-0.01-0.1-0.02-0.21-0.03-0.33c-0.02-0.12-0.04-0.23-0.07-0.33c-0.04-0.1-0.07-0.2-0.12-0.3c-0.05-0.1-0.11-0.19-0.19-0.27c-0.08-0.08-0.17-0.15-0.27-0.21c-0.12-0.07-0.22-0.1-0.31-0.09c-0.09 0.01-0.16 0.04-0.2 0.1c-0.05 0.06-0.09 0.14-0.11 0.26c-0.03 0.12-0.04 0.23-0.05 0.34c-0.01 0.11-0.01 0.24-0.01 0.38v3.99c0 0.9 0.23 1.48 0.69 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m823.6 155.29v-7.41l-1.28-0.35v-1.17c0.82 0.16 1.35 0.13 1.6-0.07l1.04 0.6v9.18l-1.36-0.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m826.99 152.58v-1.5l1.3 0.75v1.49l-1.3-0.75zm0 3.75v-1.49l1.3 0.75v1.49l-1.3-0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m831.15 159.77c-0.71-0.41-1.23-0.94-1.57-1.59c-0.34-0.65-0.51-1.39-0.51-2.22v-0.33l1.36 0.78v0.26c0.01 0.47 0.06 0.84 0.16 1.12c0.1 0.28 0.29 0.5 0.57 0.66c0.12 0.07 0.23 0.11 0.31 0.11c0.09 0 0.16-0.02 0.21-0.07c0.05-0.05 0.09-0.13 0.12-0.24c0.03-0.12 0.05-0.24 0.05-0.37c0.01-0.13 0.02-0.29 0.02-0.48c0-0.49-0.07-0.9-0.21-1.23c-0.14-0.34-0.38-0.61-0.72-0.83c-0.01-0.01-0.05-0.03-0.11-0.06c-0.06-0.04-0.09-0.05-0.1-0.06v-1.32c0.1 0.06 0.16 0.09 0.18 0.1c0.35 0.19 0.6 0.23 0.74 0.11c0.14-0.12 0.21-0.41 0.21-0.87c0-0.41-0.05-0.74-0.16-1.01c-0.11-0.27-0.3-0.48-0.57-0.63c-0.11-0.07-0.21-0.1-0.3-0.11c-0.08 0-0.15 0.02-0.2 0.06c-0.05 0.04-0.09 0.12-0.12 0.21c-0.03 0.1-0.05 0.2-0.06 0.32c-0.01 0.12-0.02 0.25-0.02 0.41v0.31l-1.36-0.79v-0.43c0-0.78 0.18-1.29 0.54-1.51c0.36-0.22 0.87-0.14 1.53 0.24c0.67 0.39 1.18 0.89 1.54 1.52c0.36 0.63 0.54 1.33 0.54 2.11c0 0.52-0.1 0.9-0.29 1.13c-0.2 0.24-0.45 0.31-0.78 0.23c0.34 0.33 0.61 0.74 0.79 1.22c0.19 0.48 0.28 1.02 0.28 1.62c0 0.88-0.17 1.46-0.5 1.76c-0.33 0.3-0.86 0.24-1.57-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m834.44 161.55l1.55-7.08l-2.1-1.21v-1.21l3.44 1.98v0.93l-1.57 7.35l-1.32-0.76z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m907.72 146.64v55.96c0 1.52-0.47 2.61-1.22 3.16l0 0l-0.04 0.03c-0.09 0.06-0.18 0.12-0.28 0.16l-11.97 6.91l-0.88-24.25l-29.26-16.84c-2.24-1.29-4.05-4.76-4.05-7.74v-34.45l-20.39-12.18l12.13-7l0 0.01c0.72-0.47 1.68-0.46 2.74 0.15l49.17 28.33c2.24 1.29 4.05 4.76 4.05 7.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m860.45 169.97l45.39-26.21c0.55 1.24 0.88 2.6 0.88 3.87v55.96c0 1.52-0.47 2.61-1.22 3.16l0 0l-0.04 0.03c-0.09 0.06-0.18 0.12-0.28 0.16l-11.97 6.91l-0.88-24.25l-29.26-16.84c-1-0.58-1.91-1.59-2.62-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m890.44 213.72l-49.17-28.33c-2.24-1.29-4.05-4.76-4.05-7.74v-55.96c0-2.98 1.81-4.36 4.05-3.06l49.17 28.33c2.24 1.29 4.05 4.76 4.05 7.74v55.96c0 2.98-1.81 4.35-4.05 3.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m896.18 153.85v55.96c0 2.23-1.02 3.56-2.46 3.55c0.48-0.61 0.77-1.52 0.77-2.7v-55.96c0-2.98-1.81-6.45-4.05-7.74l-49.17-28.33c-0.56-0.33-1.1-0.48-1.59-0.48c0.74-0.93 1.93-1.14 3.28-0.36l49.17 28.33c2.24 1.29 4.05 4.76 4.05 7.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m888 209l-44.29-25.52c-2.02-1.16-3.65-4.29-3.65-6.97v-50.41c0-2.69 1.63-3.92 3.65-2.76l44.29 25.52c2.02 1.16 3.65 4.29 3.65 6.97v50.41c0 2.69-1.63 3.92-3.65 2.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m880.87 174.84c0 9.58-6.72 13.46-15.02 8.67c-8.29-4.79-15.02-16.43-15.02-26.01c0-9.58 6.72-13.46 15.02-8.67c8.29 4.79 15.02 16.43 15.02 26.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m877.12 169.66c0 5.28-3.71 7.42-8.28 4.78c-4.57-2.64-8.28-9.06-8.28-14.34c0-5.28 3.71-7.42 8.28-4.78c4.57 2.64 8.28 9.06 8.28 14.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m872.55 167.02c0 2.37-1.66 3.33-3.72 2.15c-2.05-1.19-3.72-4.07-3.72-6.44c0-2.37 1.66-3.33 3.72-2.15c2.05 1.19 3.72 4.07 3.72 6.44z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m952.84 164.44l-32.85 18.96l0.1-1.18l32.75-18.91v1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m952.84 135.83l-32.85 18.96l0.1-1.18l32.75-18.91v1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m853.91 58.75l-33.03 19.07l-0.3-0.95l32.37-18.69l0.97 0.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m942.89 222.87v-12.28l5.12-2.95v12.28l-5.12 2.95zm0.6-11.93v10.9l3.92-2.26v-10.9l-3.92 2.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s13",
    d: "m925.88 231.78v-12.28l0.15-0.09l12.95-7.35v12.28l-0.15 0.09l-12.95 7.35zm0.6-11.93v10.91l11.9-6.76v-10.91l-11.9 6.76z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m847.86 225.64c-2.63 1.52-6.9 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1082.98 138.71c-2.63 1.52-6.9 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m340.21 743.57c-2.63 1.52-6.89 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m988.9 759.22l-160.71-92.02l-47.73 27.7l-1.18-2.03l48.89-28.38l0.59 0.34l160.13 91.69l33.69-19.45l1.17 2.03l-34.86 20.12z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1049.34 690.64l-209.67-121.24l-40.75 23.64l-60.88-35.06l1.01-1.75l59.87 34.47l40.76-23.64l0.51 0.29l210.18 121.54l-1.02 1.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.8,
      mixBlendMode: "multiply"
    }
  }), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m1051.14 756.29l-59.49-34.35l91.42-52.78l59.49 34.35l-91.42 52.78zm-54.8-34.35l54.8 31.64l86.73-50.08l-54.8-31.64l-86.73 50.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1054.62 692.06c-2.63 1.52-6.9 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.9-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1134.15 639.27l-3.41 15.46l-11.54 29.07l-14.95 21.66l-12.31 9.18l-12.88 8.95c-5.81 3.45-9.22 5.3-10.24 5.53c-1.53 0.35-13.3 1.88-13.89 2.12c-0.59 0.24-11.77-3.4-12.71-2.94c-0.63 0.31-4.83-3.5-12.59-11.42l-1.18-3.49c-2.12 0.4-4.2 0.6-6.23 0.6c-1.65 0-3.26-0.14-4.83-0.4c0-1.68 0-3.36 0-5.03c6.97 1.4 15.03-0.33 23.36-5.14l7.42-4.28c26.74-15.44 48.49-57.09 48.49-92.86v-24.66c0.92 0.55 1.84 0.6 2.77 0.6c0-0.24 0-0.5-0.01-0.79c0.36 0.28 0.72 0.54 1.08 0.81c0.37 0.02 0.74 0.05 1.11 0.14v0.67c9.91 7.12 21.34 11.79 32.21 18.17c0.03 3.35 0.14 16.03 0.35 38.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1018.68 713.74c-0.43-0.05-0.87-0.09-1.29-0.16c0-1.68 0-3.36 0-5.03c6.97 1.4 15.03-0.33 23.36-5.14l7.42-4.28c26.74-15.44 48.49-57.09 48.49-92.86v-24.66c0.92 0.55 1.84 0.6 2.77 0.6c0-0.24 0-0.5-0.01-0.79c0.36 0.28 0.72 0.54 1.08 0.81c0.37 0.02 0.74 0.05 1.11 0.14v0.67c0.38 0.27 0.78 0.52 1.16 0.79c-0.33-0.07-0.65-0.11-0.98-0.12c-0.36-0.27-0.72-0.53-1.08-0.81c0 0.29 0 0.55 0.01 0.79c-0.92-0.01-1.84-0.05-2.77-0.6v24.66c0 35.77-21.75 77.43-48.49 92.86l-7.42 4.28c-8.33 4.81-16.39 6.54-23.36 5.14c0 1.23 0 2.47 0 3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1133.98 639.44c-0.04 0.29-0.09 0.57-0.13 0.86c-1.11-0.06-2.15-0.31-2.96-0.77l-0.34-0.2c-4.35 32.35-24.02 66.31-47.58 79.91l-7.42 4.28c-11.16 6.44-21.84 7.37-30.06 2.62c-0.32-0.19-0.64-0.38-0.96-0.58c8.17 4.46 18.65 3.46 29.61-2.86l7.42-4.28c23.56-13.6 43.23-47.56 47.58-79.91l0.34 0.2c1.17 0.68 2.84 0.91 4.5 0.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1140.92 636.58c-0.01 0.91-0.67 1.86-1.97 2.61c-2.39 1.38-6 1.53-8.06 0.33l-38.44-22.19c-0.92-0.53-1.38-1.24-1.39-1.99l0 0l0-34.44l39.16 16.58l10.71 4.54l0 34.57l-0.01 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m1140.22 601.31l-11.42-4.54l-38.45-16.58l49.87 21.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1140.93 602.01l0 34.57l0 0c-0.01 0.91-0.67 1.86-1.97 2.61c-1.42 0.82-3.27 1.19-4.97 1.12v-41.24l6.94 2.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1130.89 605.1l-38.44-22.19c-2.07-1.19-1.81-3.28 0.58-4.66c2.39-1.38 6-1.53 8.06-0.33l38.44 22.19c2.07 1.19 1.81 3.28-0.58 4.66c-2.39 1.38-6 1.53-8.06 0.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1117.14 551.07l-8.53 0.54l-8.36-0.24l-9.18 2.47l-10.57 5.06l-11.65 8.74l-4.59 4.06l-6.27 4.86l-4.15 5.03l-6.09 10.24l-4.5 6.44l-4.86 10.3l-5.12 13.53l-2.47 10.59l-2.3 13.07v25.95l0.18 11.65l0.71 18.89l3.71 16.42l9.19 11.29l-32.22-18.7l0.01 0c-0.63-0.3-1.26-0.62-1.87-0.98c-11.71-6.76-18.42-22.2-18.42-42.35v-32.49c0-37.34 22.86-80.92 50.96-97.15l7.42-4.28c12.56-7.25 24.8-8.25 34.55-2.87l0.03 0l0.32 0.19c0.03 0.02 0.07 0.04 0.11 0.06c0.05 0.03 0.1 0.06 0.15 0.09l33.82 19.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1134.81 601.62c-1.11 0.64-2.11 1.41-3.22 0.77l-34.15-19.79c-0.65-0.37-0.91-0.88-0.8-1.37v-7.46c0-8.1-1.14-15.32-3.28-21.37c0.66-0.19 1.33-0.35 2-0.5c-0.04-0.16-0.06-0.27-0.06-0.29c0-0.24 3.65-0.59 10.95-1.06l17.42 7.06c3.53 6.04 5.38 9.18 5.53 9.42c0.16 0.24 1.53 6.55 4.12 18.95c0.06 1.8 0.12 3.72 0.19 5.77l1.05 7.65l-0.12-0.01l0.4 0.7c1.11 0.64 1.08 0.89-0.03 1.53z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m1030.82 718.08c-0.49-0.49-0.89-0.9-1.2-1.21l-0.64-1.88c0.25-0.04 0.5-0.08 0.75-0.12l1.09 3.21z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1097.94 582.88l-0.49-0.28c-0.65-0.37-0.91-0.88-0.8-1.37v-7.46c0-8.1-1.14-15.32-3.28-21.37c0.66-0.19 1.33-0.35 2-0.5c-0.04-0.16-0.06-0.27-0.06-0.29c0-0.24 3.65-0.59 10.95-1.06l17.42 7.06c0.2 0.34 0.44 0.76 0.74 1.26l-16.87-6.84c-7.3 0.47-10.95 0.82-10.95 1.06c0 0.03 0.02 0.13 0.06 0.29c-0.67 0.15-1.34 0.31-2 0.5c2.14 6.05 3.28 13.27 3.28 21.37v7.45c-0.01 0.06 0 0.11-0.01 0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m1135.61 602.39c-1.11 0.64-2.91 0.64-4.02 0l-0.13-0.08v-4.71v-0.46v-3.24c0-18.34-5.81-32.22-15.95-38.07c-3.46-2-7.36-2.99-11.54-2.99c-5.76 0-12.06 1.88-18.52 5.61l-7.42 4.28c-26.74 15.44-48.49 57.1-48.49 92.86v32.49c0 18.34 5.81 32.22 15.95 38.07c8.23 4.75 18.9 3.82 30.06-2.62l7.42-4.28c23.56-13.6 43.23-47.56 47.58-79.91l0.34 0.2c1.17 0.68 2.84 0.91 4.5 0.74c-4.67 33.68-25.28 69.02-49.95 83.26l-7.42 4.28c-7.24 4.18-14.39 6.29-21 6.29c-5.03 0-9.76-1.22-14-3.67c-11.71-6.76-18.42-22.2-18.42-42.35v-32.49c0-37.34 22.86-80.92 50.96-97.15l7.42-4.28c12.75-7.36 25.18-8.29 35.01-2.62c11.71 6.76 18.42 22.2 18.42 42.35l0.01 7.25c0.04 0.45-0.21 0.9-0.8 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1135.61 602.39c-1.11 0.64-2.91 0.64-4.02 0l-0.13-0.08v-4.71v-0.46v-3.24c0-18.34-5.81-32.22-15.95-38.07c-3.46-2-7.36-2.99-11.54-2.99c-5.76 0-12.06 1.88-18.52 5.61l-7.42 4.28c-26.74 15.44-48.49 57.1-48.49 92.86v32.49c0 18.34 5.81 32.22 15.95 38.07c8.23 4.75 18.9 3.82 30.06-2.62l7.42-4.28c23.56-13.6 43.23-47.56 47.58-79.91l0.34 0.2c1.17 0.68 2.84 0.91 4.5 0.74c-4.67 33.68-25.28 69.02-49.95 83.26l-7.42 4.28c-7.24 4.18-14.39 6.29-21 6.29c-5.03 0-9.76-1.22-14-3.67c-11.71-6.76-18.42-22.2-18.42-42.35v-32.49c0-37.34 22.86-80.92 50.96-97.15l7.42-4.28c12.75-7.36 25.18-8.29 35.01-2.62c11.71 6.76 18.42 22.2 18.42 42.35l0.01 7.25c0.04 0.45-0.21 0.9-0.8 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1117.55 551.31c-9.75-5.4-22.01-4.4-34.57 2.85l-7.42 4.28c-22.66 13.08-41.9 43.96-48.51 75c-0.43-0.29-0.91-0.54-1.43-0.74c6.59-31.07 25.85-61.99 48.53-75.08l7.42-4.28c12.75-7.36 25.18-8.29 35.01-2.62c0.33 0.19 0.66 0.39 0.98 0.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m1042.09 729.86c-0.16-0.09-0.32-0.16-0.47-0.25c-6.18-3.57-10.96-9.55-14.11-17.36c0.32-0.11 0.64-0.22 0.96-0.37c2.98 7.99 7.6 14.18 13.63 17.98z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1131.46 593.89v3.24v0.46v4.71l-1.25-0.72c-0.01-0.01-0.02-0.02-0.03-0.02l-0.13-0.08v-4.71v-0.46v-3.24c0-17.78-5.46-31.36-15.03-37.51c0.16 0.09 0.33 0.17 0.49 0.26c10.14 5.85 15.95 19.73 15.95 38.07z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1049.85 646.56v75c0 2.58-0.87 4.39-2.24 5.15l0.01 0l-8.3 4.8l1.48-6.73l-59.55-34.38c-3.5-2.02-6.34-7.44-6.34-12.1v-72.76l-6.32-2.44l8.56-4.96l0 0.01c1.1-0.61 2.53-0.54 4.09 0.36l62.27 35.95c3.5 2.02 6.34 7.44 6.34 12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1039.32 731.52l1.48-6.73l-59.55-34.38c-2.5-1.44-4.64-4.63-5.67-8.03l72.8-42.03c0.91 1.99 1.48 4.17 1.48 6.22v75c0 2.58-0.87 4.39-2.24 5.15l0.01 0l-8.3 4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1035.03 731.27l-62.27-35.95c-3.5-2.02-6.34-7.44-6.34-12.1v-75c0-4.67 2.84-6.81 6.34-4.79l62.27 35.95c3.5 2.02 6.34 7.44 6.34 12.1v75c0 4.67-2.84 6.81-6.34 4.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1043.12 650.63v75c0 3.21-1.36 5.19-3.34 5.47c0.98-0.92 1.59-2.49 1.59-4.63v-75c0-4.67-2.84-10.08-6.34-12.1l-62.27-35.95c-1.09-0.63-2.1-0.81-2.99-0.68c1.16-1.09 2.84-1.26 4.74-0.16l62.27 35.95c3.5 2.02 6.34 7.44 6.34 12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1033.38 727.88l-58.96-34.04c-3.31-1.91-6-7.04-6-11.46v-71.02c0-4.42 2.69-6.45 6-4.53l58.96 34.04c3.31 1.91 6 7.04 6 11.46v71.02c0 4.42-2.69 6.45-6 4.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1048.38 684.4c0 1.68-1.18 3.72-2.63 4.56c-1.45 0.84-2.63 0.16-2.63-1.52c0-1.68 1.18-3.72 2.63-4.56c1.45-0.84 2.63-0.16 2.63 1.52z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1027.93 740.83c-2.63 1.52-6.89 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1044.32 335.36l-1.01-1.75l120.9-69.88l-98.27-56.84l66.6-38.33l-54.83-31.71l1.02-1.75l57.86 33.47l-66.6 38.33l98.27 56.84l-123.94 71.63z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m467.23 768.36l-43.46-25.72l-43.53 25.15l-0.51-0.29l-44.8-25.8l1.01-1.75l44.29 25.51l43.54-25.16l43.46 25.72l44.93-25.81l1.01 1.76l-45.95 26.39z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m373.77 489.82l-128.82-75.02l1.02-1.75l128.82 75.02l-1.02 1.75z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m462.86 571.45c-2.63 1.52-6.9 1.52-9.53 0c-2.63-1.52-2.63-3.98 0-5.5c2.63-1.52 6.89-1.52 9.53 0c2.63 1.52 2.63 3.98 0 5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.6,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group> copy",
    style: {
      opacity: 0.6,
      mixBlendMode: "multiply"
    }
  }), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m936.13 556.5l-46.6-26.91l46.6-26.91l46.6 26.91l-46.6 26.91zm-42.55-26.91l42.55 24.57l42.55-24.57l-42.55-24.57l-42.55 24.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m966.79 520.74l-30.66 17.7v-35.4l30.66-17.7v35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m936.13 503.04l-30.66-17.7l30.66-17.7l30.66 17.7l-30.66 17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m936.13 538.44l-30.66-17.7v-35.4l30.66 17.7v35.4z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m925.09 519.32l-8.58-4.95v-9.9l8.58 4.95v9.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m936.13 491.07l-9.92-5.73l9.92-5.73l9.92 5.73l-9.92 5.73z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m900.57 441.81l-49.42-28.01l-35.32 20.27l-1.01-1.76l36.32-20.84l49.42 28.01l33.15-19.09l1.01 1.75l-34.15 19.67z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m361.79 415.56l-46.6-26.91l46.6-26.91l46.6 26.91l-46.6 26.91zm-42.55-26.91l42.55 24.57l42.55-24.57l-42.55-24.57l-42.55 24.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m392.45 379.8l-30.66 17.7v-35.4l30.66-17.7v35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m361.79 361.1l-30.66-17.7l30.66-17.7l30.66 17.7l-30.66 17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m361.79 350.13l-9.92-5.73l9.92-5.73l9.92 5.73l-9.92 5.73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m361.79 397.51l-30.66-17.7v-35.4l30.66 17.7v35.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m350.75 378.38l-8.58-4.95v-9.9l8.58 4.95v9.9z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m458.23 681.57l-46.6-26.91l46.6-26.91l46.6 26.91l-46.6 26.91zm-42.55-26.91l42.55 24.57l42.55-24.57l-42.55-24.57l-42.55 24.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m488.89 645.82l-30.66 17.7v-35.4l30.66-17.7v35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m458.23 628.11l-30.66-17.7l30.66-17.7l30.66 17.7l-30.66 17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m458.23 663.52l-30.66-17.7v-35.4l30.66 17.7v35.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m447.19 644.39l-8.58-4.95v-9.9l8.58 4.95v9.9z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m999.77 663.28l-9.53-5.5c-0.84-0.49-1.53-1.79-1.53-2.92v-10.46c0-1.12 0.68-1.64 1.53-1.15l9.53 5.5c0.84 0.49 1.53 1.79 1.53 2.92v10.46c0 1.12-0.68 1.64-1.53 1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m1016.39 672.87l-9.53-5.5c-0.84-0.49-1.53-1.79-1.53-2.92v-10.46c0-1.12 0.68-1.64 1.53-1.15l9.53 5.5c0.84 0.49 1.53 1.79 1.53 2.92v10.46c0 1.12-0.68 1.64-1.53 1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m999.77 681.85l-9.53-5.5c-0.84-0.49-1.53-1.79-1.53-2.92v-10.46c0-1.12 0.68-1.64 1.53-1.15l9.53 5.5c0.84 0.49 1.53 1.79 1.53 2.92v10.46c0 1.12-0.68 1.64-1.53 1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1016.39 691.45l-9.53-5.5c-0.84-0.49-1.53-1.79-1.53-2.92v-10.46c0-1.12 0.68-1.64 1.53-1.15l9.53 5.5c0.84 0.49 1.53 1.79 1.53 2.92v10.46c0 1.12-0.68 1.64-1.53 1.15z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiplomatechIllustration1);
export default __webpack_public_path__ + "static/media/diplomatech-illustration1.c5383f91cbe8fbe3232c75e1cac11ee1.svg";
export { ForwardRef as ReactComponent };